<template>
  <div id="insure">
    <p style="margin-bottom: 0;">
      <strong style="color: #096dd9; text-align: center;"
        ><span>中国人民财产保险股份有限公司法定传染病保险条款</span></strong
      >
    </p>
    <p style="text-align: center;">
      注册号：C00000232612020020723612
    </p>
    <p>
      <strong
        ><span
          >1 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span>总则</span>
    </p>
    <p data-lake-id="edca57690079654554a7137d2a9a50e1">
      <strong
        ><span>1.1 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </span></strong
      ><strong><span>合同构成</span></strong>
    </p>
    <p style="text-align: justify; text-indent: 21pt;">
      <span
        >本保险合同由保险条款、投保单、保险单、声明、批单以及经投保人与保险人</span
      ><span
        >认可的、与保险合同有关的其它书面协议组成。凡涉及本保险合同的约定，均应采</span
      ><span>用书面形式。</span>
    </p>
    <p data-lake-id="f91a3e1bf29a2b1888779a1bd7f55dd4">
      <strong
        ><span>1.2 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </span></strong
      ><span>投保人</span>
    </p>
    <p data-lake-id="35f24d2ae71bc20c326673f881bb18fb">
      具有完全民事行为能力的被保险人本人或对被保险人有保险利益的自然人或团体可作为投保人。
    </p>
    <p data-lake-id="d0dacb5a839704421d065c3490c6e146">
      <strong
        ><span>1.3 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </span></strong
      ><span>被保险人</span>
    </p>
    <p data-lake-id="7bd88f0c131a2fcbbd18d7d67ebd2b5f">
      投保时身体健康、能正常工作、生活的自然人可作为本保险合同的被保险人。
    </p>
    <p data-lake-id="bd513b39652b21599a1653110db7a862">
      <strong><span>1.3.1 &nbsp; </span></strong><span>被保资格的获得</span>
    </p>
    <p
      data-lake-id="3e0a587e495b56df5eab3b7462d14b7d"
      style="text-align: justify; text-indent: 21pt;"
    >
      <span>经保险人审核同意并出具保险单或批单，符合 </span>1.3
      中约定的人员可获得被保资<span>格，成为被保险人。</span>
    </p>
    <p
      data-lake-id="b3a0b17b7b0155f52d551b4042929a17"
      style="text-align: justify; text-indent: 21pt;"
    >
      被保险人获得被保资格的日期以以下两者中较晚的日期为准：（1）本保险合同的保险期间起始日；（2）增加该被保险人的批单所载生效日，有多张批单增加该被保险人的，以最晚批单所载生效日为准。
    </p>
    <p data-lake-id="015ef7d78aa851faa98dcc5b66a60df4">
      <strong><span>1.3.2 &nbsp; </span></strong
      ><span>被保资格的丧失或终止</span>
    </p>
    <p
      data-lake-id="f854fe6096fab7e48e27d3fd24e9b59a"
      style="text-indent: 21pt;"
    >
      <span
        >被保险人身故的，则自其身故之日起该被保险人的被保资格丧失，保险人对该</span
      ><span>被保险人所承担的保险责任随即终止。</span>
    </p>
    <p data-lake-id="56122d5bc52325c95f2920e1fcaa35c3">
      <strong
        ><span>1.4 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </span></strong
      ><span>受益人</span>
    </p>
    <p data-lake-id="45b3f2191422438497bfcf7706423af9">
      法定传染病身故保险金的受益人由投保人或被保险人指定并在保险单中载明。
    </p>
    <p
      data-lake-id="8fd6cee7ccebe982fdb779abc18659f3"
      style="text-indent: 21pt;"
    >
      <span
        >除另有约定外，法定传染病确诊保险金、法定传染病住院津贴保险金的受益人</span
      ><span>为被保险人本人。</span>
    </p>
    <p data-lake-id="305aca4f028422177018c6d349397ee7">
      <strong
        ><span
          >2 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span>保障内容</span>
    </p>
    <p data-lake-id="00c49bf385bcc60f0f62be66904255b0">
      <strong
        ><span>2.1 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </span></strong
      ><strong><span>保险责任</span></strong>
    </p>
    <p data-lake-id="976eab154cfe43ed5f56d30b6e3dc70c">
      经保险人同意，投保人可在投保 2.1.1 保险责任的基础上选择投保 2.1.2、
    </p>
    <p data-lake-id="d0a439b8a4b0deea250980feaa4e4cb8">
      2.1.3 中的一项或两项保险责任，并在保险单中载明。
    </p>
    <p data-lake-id="8c7a562747d77bbc0eacb1f532695586">
      <strong><span>2.1.1 &nbsp; </span></strong
      ><span>法定传染病确诊保险责任</span>
    </p>
    <p style="text-indent: 21pt;">
      <span
        >在保险期间内，被保险人自获得被保资格之日起经过本保险合同约定的等待期</span
      ><span>后发病</span><span>（</span><span>见释义</span><span>）</span
      ><span>，被中华人民共和国境内</span>（<span
        >不包括香港、澳门和台湾地区</span
      ><span>）</span><span>二级</span>
    </p>
    <p data-lake-id="69af1a5dbfb1d450dc0fa01e4f348a84">
      （含）<span>及以上公立医院（</span>见释义）<span>或卫生健康委员会指定的法定传染病</span>（<span>见释义</span>）
      <span
        >诊治定点医院确诊为本保险合同约定类型的法定传染病的，保险人按该被保险人的</span
      ><span
        >法定传染病确诊保险金额给付保险金，对该被保险人的该项保险责任终止。</span
      >
    </p>
    <p data-lake-id="204f251cdada3840e00b03e6c43d51b5">
      <span
        >本保险合同约定类型的法定传染病由投保人、保险人双方协商确定，并在保险单中载明。</span
      >
    </p>
    <p data-lake-id="70f236a902a8e93664b4be31e08b4b92">
      <strong><span>2.1.2 &nbsp; </span></strong
      ><strong><span>法定传染病身故保险责任</span></strong>
    </p>
    <p style="text-align: justify; text-indent: 21pt;">
      <span
        >在保险期间内，被保险人自获得被保资格之日起经过本保险合同约定的等待期</span
      ><span>后发病，被中华人民共和国境内</span><span>（</span
      ><span>不包括香港、澳门和台湾地区</span><span>）</span><span>二级</span
      ><span>（含</span
      ><span>）</span
      >及以上公立医院或卫生健康委员会指定的法定传染病诊治定点医院确诊为本保险合同<span
        >约定类型的法定传染病，并因该法定传染病在保险期间内身故的，保险人按该被保</span
      ><span
        >险人的法定传染病身故保险金额给付保险金，对该被保险人的保险责任终止。</span
      >
    </p>
    <p style="text-indent: 31.9pt;">
      <span
        >本保险合同约定类型的法定传染病由投保人、保险人双方协商确定，并在保险</span
      ><span>单中载明。</span>
    </p>
    <p data-lake-id="2d3c2a022c648ad48fe505ebf5abb2c0">
      <strong><span>2.1.3 &nbsp; </span></strong
      ><strong><span>法定传染病住院津贴保险责任</span></strong>
    </p>
    <p style="text-align: justify; text-indent: 21pt;">
      <span
        >在保险期间内，被保险人自获得被保资格之日起经过本保险合同约定的等待期</span
      ><span>后发病，被中华人民共和国境内</span><span>（</span
      ><span>不包括香港、澳门和台湾地区</span><span>）</span><span>二级</span
      ><span>（含</span
      ><span>）</span
      >及以上公立医院或卫生健康委员会指定的法定传染病诊治定点医院确诊为本保险合同<span
        >约定类型的法定传染病，并在上述医院接受住院</span
      ><span>（</span><span>见释义</span><span>）</span
      ><span>治疗的，对于被保险人</span
      ><span
        >在保险期间内的实际住院日数，保险人按照下述公式计算并给付法定传染病住院津</span
      ><span>贴保险金，且对每一被保险人给付的津贴日数不超过总给付日数：</span>
    </p>
    <p style="text-indent: 23.95pt;">
      保险金计算公式：住院津贴保险金=实际住院日数×每日住院津贴金额总给付日数、每日住院津贴金额以及本保险合同约定类型的法定传染病由投<span
        >保人、保险人双方协商确定，并在保险单中载明。</span
      >
    </p>
    <p style="text-align: justify; text-indent: 24pt;">
      <span
        >保险期间届满被保险人仍在住院治疗的，保险人所负保险责任期限按下列约定</span
      ><span>延长：自保险期间届满次日起计算，至出院之日止，最长以 </span>30
      <span>日为限，且对每一被保险人累计给付的津贴日数不超过总给付日数。</span>
    </p>
    <p data-lake-id="40a593e4073ed071913d05a7a5343ba7">
      <strong
        ><span>2.2 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </span></strong
      ><span>责任免除</span>
    </p>
    <p style="text-indent: 21.1pt;">
      <strong
        ><span
          >因下列情形之一导致被保险人被确诊法定传染病、身故或接受住院治疗的，保</span
        ></strong
      ><strong><span>险人不承担给付保险金责任：</span></strong>
    </p>
    <p style="text-align: justify;">
      <strong><span>（</span></strong
      ><strong><span>1</span></strong
      ><strong><span>）</span></strong
      ><strong
        ><span
          >被保险人在投保前已被确诊为本保险合同约定类型的法定传染病且未被</span
        ></strong
      ><strong><span>治愈的；</span></strong>
    </p>
    <p
      data-lake-id="f57ffc5aa1c8e78a9f07a11293b77978"
      style="text-align: justify;"
    >
      <strong><span>（</span></strong
      ><strong><span>2</span></strong
      ><strong><span>）</span></strong
      ><strong
        ><span
          >被保险人已被确认为本保险合同约定类型法定传染病的疑似病例且未被</span
        ></strong
      ><strong><span>排除的；</span></strong>
    </p>
    <p
      data-lake-id="68b2d8901d8282f7ba4bc87049fad263"
      style="text-align: justify;"
    >
      <strong><span>（</span></strong
      ><strong><span>3</span></strong
      ><strong><span>）</span></strong
      ><strong><span>非本保险合同约定类型的法定传染病；</span></strong>
    </p>
    <p
      data-lake-id="45ef33cd3ce49e5126e243c7b35deff9"
      style="text-align: justify;"
    >
      <strong><span>（</span></strong
      ><strong><span>4</span></strong
      ><strong><span>）</span></strong
      ><strong><span>被保险人未遵医嘱服用、涂用、注射药物；</span></strong>
    </p>
    <p
      data-lake-id="9e1bd381daa02a8f9358121315612a1e"
      style="text-align: justify;"
    >
      <strong><span>（</span></strong
      ><strong><span>5</span></strong
      ><strong><span>）</span></strong
      ><strong
        ><span
          >被保险人受酒精、毒品、管制药物的影响，但遵医嘱使用药物的情形不</span
        ></strong
      ><strong><span>在此限；</span></strong>
    </p>
    <p
      data-lake-id="8ec7d52072bd990b359ec79bb27a500a"
      style="text-align: justify;"
    >
      <strong><span>（</span></strong
      ><strong><span>6</span></strong
      ><strong><span>）</span></strong
      ><strong
        ><span
          >任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤
        </span></strong
      ><strong><span>、污染或辐射；</span></strong>
    </p>
    <p style="text-align: justify;">
      <strong><span>（</span></strong
      ><strong><span>7</span></strong
      ><strong><span>）</span></strong
      ><strong
        ><span>被保险人故意犯罪或抗拒依法采取的刑事强制措施；</span></strong
      >
    </p>
    <p style="text-align: justify;">
      <strong><span>（</span></strong
      ><strong><span>8</span></strong
      ><strong><span>）</span></strong
      ><strong
        ><span
          >等待期内被保险人已经出现症状，且在等待期内或延续到等待期后被确</span
        ></strong
      ><strong><span>诊为本保险合同约定类型的法定传染病。</span></strong>
    </p>
    <p data-lake-id="0a6b7b2d1888cb32102acfe8eb74a93d">
      <strong
        ><span class="lake-fontsize-10"
          >2.3 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><strong><span class="lake-fontsize-10">保险金额</span></strong>
    </p>
    <p
      data-lake-id="ec9c3de0ec2360983366339bc5387e25"
      style="text-indent: 7.1pt;"
    >
      每一被保险人的保险金额是保险人承担给付该被保险人保险金责任的最高限额。
    </p>
    <p
      data-lake-id="1504d473682cea9f308131320c8f6b96"
      style="text-indent: 7.1pt;"
    >
      <span
        >法定传染病确诊保险金额、法定传染病身故保险金额、法定传染病住院津贴保</span
      ><span>险金额由投保人、保险人双方约定，并在保险单中载明。</span>
    </p>
    <p
      data-lake-id="9886e2ac110c4a027d0535fa1c8d59e7"
      style="text-indent: 41.05pt;"
    >
      每一被保险人的保险金额一经确定，在保险期间内不得变更。
    </p>
    <p data-lake-id="82f4302d94cf803352f153a06b636ea7">
      <strong
        ><span class="lake-fontsize-10"
          >2.4 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">保险期间</span>
    </p>
    <p data-lake-id="e80ffcd23081d785942c07dff4b0ce6c">
      除另有约定外，保险期间为 1 年，以保险单载明的起讫时间为准。
    </p>
    <p data-lake-id="a62b9505f9b4e87023e4c18c266faee2">
      <strong
        ><span class="lake-fontsize-10"
          >3 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">投保人、被保险人义务</span>
    </p>
    <p data-lake-id="a78a6b70df089a3f51ac2df7c542e410">
      <strong
        ><span class="lake-fontsize-10"
          >3.1 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><strong><span class="lake-fontsize-10">交费义务</span></strong>
    </p>
    <p data-lake-id="b2e6ae6f3a74647658d50c1bc5a6ae63">
      除另有约定外，投保人应当在保险合同成立时交清保险费。
    </p>
    <p data-lake-id="fdd2f04c4e95aa33e68d31ef531fbc14">
      <strong
        ><span class="lake-fontsize-10"
          >3.2 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">如实告知义务</span>
    </p>
    <p data-lake-id="22df45e0e2c46d7b8747bc61cea466ce">
      投保人应如实填写投保单并回答保险人提出的询问，履行如实告知义务。
    </p>
    <p data-lake-id="30b5971324941be47a90de6a156f28ce">
      <strong
        ><span class="lake-fontsize-10"
          >3.3 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">住址或通讯地址变更通知义务</span>
    </p>
    <p data-lake-id="211c57123cb90524df061c380f6c870b">
      投保人住所或通讯地址变更时，应及时以书面形式通知保险人。
    </p>
    <p data-lake-id="d3e377a273b3aa528db60dde7fb8918a">
      <strong
        ><span class="lake-fontsize-10"
          >3.4 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">变更批注</span>
    </p>
    <p
      data-lake-id="517dc36204b23bc64f415d4c66303fd5"
      style="text-indent: 21pt;"
    >
      <span
        >在保险期间内，投保人需变更合同内容的，应以书面形式向保险人提出申请。</span
      ><span
        >保险人同意后出具批单，并在本保险合同中批注。若被保险人已身故，则保险人不</span
      ><span>接受本保险合同中有关该被保险人的任何内容的变更申请。</span>
    </p>
    <p data-lake-id="c03a195c0eee4858e93b7ca1ca3faf4a">
      <strong
        ><span class="lake-fontsize-10"
          >3.5 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">保险事故通知义务</span>
    </p>
    <p
      data-lake-id="0c739fd54e33dcba54a4e8f99cee903f"
      style="text-indent: 21pt;"
    >
      <span
        >发生保险责任范围内的事故后，投保人、被保险人或受益人应及时通知保险人， </span
      ><span>并书面说明事故发生的原因、经过和损失情况。</span>
    </p>
    <p data-lake-id="d6858d6704d1e36eb2da369961e34106">
      <strong
        ><span class="lake-fontsize-10"
          >4 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">保险人义务</span>
    </p>
    <p
      data-lake-id="996d37f5202ad126f2aab1346a768aab"
      style="text-indent: 21pt;"
    >
      <span class="lake-fontsize-9">（1） &nbsp;</span
      ><span class="lake-fontsize-10"
        >本保险合同成立后，保险人应当及时向投保人签发保险单或其他保险凭</span
      ><span class="lake-fontsize-10">证。</span>
    </p>
    <p
      data-lake-id="480002f1ae33265506a356f77b7e176e"
      style="text-indent: 21pt;"
    >
      <span class="lake-fontsize-9">（2） &nbsp;</span
      ><span class="lake-fontsize-10"
        >保险人认为投保人、被保险人或者受益人提供的有关索赔的证明和资料</span
      ><span class="lake-fontsize-10"
        >不完整的，应当及时一次性通知投保人、被保险人或者受益人补充提供。</span
      >
    </p>
    <p
      data-lake-id="3ddebec7b7d1aa642e3d52b56b302bcd"
      style="text-indent: 21pt; text-align: justify;"
    >
      <span class="lake-fontsize-9">（3） &nbsp;</span
      ><span class="lake-fontsize-10"
        >保险人收到被保险人或者受益人的给付保险金的请求后，应当及时作出</span
      ><span class="lake-fontsize-10"
        >是否属于保险责任的核定；情形复杂的，应当在三十日内作出核定。但保险责任的</span
      ><span class="lake-fontsize-10"
        >核定必须依赖于特定证明、鉴定、判决、裁定或其他证据材料的，保险人应在被保</span
      ><span class="lake-fontsize-10"
        >险人或者受益人提供或自行取得上述证据材料起三十日内作出核定。本合同另有约</span
      ><span class="lake-fontsize-10">定的除外。</span>
    </p>
    <p
      data-lake-id="8e2102e86619654cd28b3682ed40b3b7"
      style="text-indent: 21pt;"
    >
      <span class="lake-fontsize-9">（4） &nbsp;</span
      ><span class="lake-fontsize-10"
        >保险人应当将核定结果通知被保险人或者受益人；对属于保险责任的， </span
      ><span class="lake-fontsize-10"
        >在与被保险人或者受益人达成给付保险金的协议后十日内，履行赔偿保险金义务。</span
      ><span class="lake-fontsize-10"
        >保险合同对给付保险金的期限有约定的，保险人应当按照约定履行给付保险金的义</span
      ><span class="lake-fontsize-10"
        >务。保险人依照前款约定作出核定后，对不属于保险责任的，应当自作出核定之日</span
      ><span class="lake-fontsize-10"
        >起三日内向被保险人或者受益人发出拒绝给付保险金通知书，并说明理由。</span
      >
    </p>
    <p
      data-lake-id="e5d05468478d2bca18d8f2aa895de706"
      style="text-indent: 21pt; text-align: justify;"
    >
      <span class="lake-fontsize-9">（5） &nbsp;</span
      ><span class="lake-fontsize-10"
        >保险人自收到给付保险金的请求和有关证明、资料之日起六十日内，对</span
      ><span class="lake-fontsize-10"
        >其赔偿保险金的数额不能确定的，应当根据已有证明和资料可以确定的数额先予支</span
      ><span class="lake-fontsize-10"
        >付；保险人最终确定给付的数额后，应当支付相应的差额。</span
      >
    </p>
    <p data-lake-id="d16eaea956fbee79c69ca370714eaa76">
      <strong
        ><span class="lake-fontsize-10"
          >5 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">保险金申请</span>
    </p>
    <p
      data-lake-id="4facb140a5e8aa5de3a175862a1aeee7"
      style="text-align: justify; text-indent: 21pt;"
    >
      <span
        >保险金申请人向保险人申请给付保险金时，应填写保险金给付申请书，并提交</span
      ><span
        >以下材料。保险金申请人因特殊原因不能提供以下材料的，应提供其它合法有效的</span
      ><span
        >材料。若保险金申请人委托他人申请的，还应提供授权委托书原件、委托人和受托人的身份证明等相关证明文件。保险人按照本保险合同的约定，认为有关的证明和</span
      ><span>资料不完整的，应当及时一次性通知保险金申请人补充提供。</span>
    </p>
    <p data-lake-id="a6b34b3698c06c7fe4cdaa68d7fa247c">
      <strong
        ><span class="lake-fontsize-10"
          >5.1 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">法定传染病确诊保险金申请</span>
    </p>
    <p data-lake-id="5c6b787b65af9e27898c931726183552">
      <span class="lake-fontsize-9">（1） </span
      ><span class="lake-fontsize-10">保险金给付申请书；</span>
    </p>
    <p data-lake-id="4514c42e6830cb136c4be8b7764ea9e9">
      <span class="lake-fontsize-9">（2） </span
      ><span class="lake-fontsize-10">保险单；</span>
    </p>
    <p data-lake-id="637cde2b69a9fa4ad9da3372945d533a">
      <span class="lake-fontsize-9">（3） </span
      ><span class="lake-fontsize-10">保险金申请人的身份证明；</span>
    </p>
    <p
      data-lake-id="63a130b6879913b8020930ebb53ffe69"
      style="text-indent: 21pt; text-align: justify;"
    >
      <span class="lake-fontsize-9">（4） </span
      ><span class="lake-fontsize-10">中华人民共和国境内</span
      ><span class="lake-fontsize-10"
        >（<span>不包括港、澳、台地区</span>）二级（<span>含</span>）<span
          >及以上公立</span
        ><span
          >医院或卫生健康委员会指定的法定传染病诊治定点医院出具的诊断证明、病历、出</span
        ><span>院小结等；</span></span
      >
    </p>
    <p
      data-lake-id="8fb28c037e117928dd84192e8c2cda50"
      style="text-indent: 21pt;"
    >
      <span class="lake-fontsize-9">（5） </span
      ><span class="lake-fontsize-10"
        >被保险人所能提供的与确认保险事故的性质、原因、损失程度等有关的</span
      ><span class="lake-fontsize-10">其他证明和资料。</span>
    </p>
    <p data-lake-id="c1d7236daa43464e995c3faedcc60b07">
      <strong
        ><span class="lake-fontsize-10"
          >5.2 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">法定传染病身故保险金申请</span>
    </p>
    <p data-lake-id="658ba3be454c58313c183f190870995c">
      <span class="lake-fontsize-9">（1） </span
      ><span class="lake-fontsize-10">保险金给付申请书；</span>
    </p>
    <p data-lake-id="e1131b78212e37fa37d4c3918be1dd2a">
      <span class="lake-fontsize-9">（2） </span
      ><span class="lake-fontsize-10">保险单；</span>
    </p>
    <p data-lake-id="dfad0b556fa634c082b358511b2be7d1">
      <span class="lake-fontsize-9">（3） </span
      ><span class="lake-fontsize-10">保险金申请人的身份证明；</span>
    </p>
    <p
      data-lake-id="1e5f379cd59644a7c6bce0c04ebab0c9"
      style="text-indent: 21pt; text-align: justify;"
    >
      <span class="lake-fontsize-9">（4） </span
      ><span class="lake-fontsize-10">中华人民共和国境内</span
      ><span class="lake-fontsize-10"
        >（<span>不包括港、澳、台地区</span>）二级（<span>含</span>）<span
          >及以上公立</span
        ><span
          >医院或卫生健康委员会指定的法定传染病诊治定点医院出具的诊断证明、病历、出</span
        ><span>院小结等；</span></span
      >
    </p>
    <p data-lake-id="b44515882c27231cc0578692044cb9c0">
      <span class="lake-fontsize-9">（5） </span
      ><span class="lake-fontsize-10"
        >公安部门或医疗机构出具的被保险人死亡证明书或验尸报告；</span
      >
    </p>
    <p
      data-lake-id="cf1eb7913c7d59c6733a94ef198de130"
      style="text-indent: 21pt;"
    >
      <span class="lake-fontsize-9">（6） </span
      ><span class="lake-fontsize-10"
        >被保险人所能提供的与确认保险事故的性质、原因、损失程度等有关的</span
      ><span class="lake-fontsize-10">其他证明和资料。</span>
    </p>
    <p data-lake-id="ac3f7ec025e1abb13fd7eaf3a4b5daf1">
      <strong
        ><span class="lake-fontsize-10"
          >5.3 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">法定传染病住院津贴保险金申请</span>
    </p>
    <p data-lake-id="3f29911c41a2f49c838d503965660588">
      <span class="lake-fontsize-9">（1） </span
      ><span class="lake-fontsize-10">保险金给付申请书；</span>
    </p>
    <p data-lake-id="a90f5b201912b006d85277b42ee64917">
      <span class="lake-fontsize-9">（2） </span
      ><span class="lake-fontsize-10">保险单；</span>
    </p>
    <p data-lake-id="0a00886ad130163abdab7bac6344e21d">
      <span class="lake-fontsize-9">（3） </span
      ><span class="lake-fontsize-10">保险金申请人的身份证明；</span>
    </p>
    <p
      data-lake-id="8904befad7688cd4827e5ceb8a178902"
      style="text-indent: 21pt; text-align: justify;"
    >
      <span class="lake-fontsize-9">（4） </span
      ><span class="lake-fontsize-10">中华人民共和国境内</span
      ><span class="lake-fontsize-10"
        >（<span>不包括港、澳、台地区</span>）二级（<span>含</span>）<span>及以上公立</span>医院或卫生健康委员会指定的法定传染病诊治定点医院出具的医疗费用收据及明<span>细清单</span>/<span
          >帐、诊断证明、病历、出院小结等；</span
        ></span
      >
    </p>
    <p
      data-lake-id="21a157486b1e380bcddbcff38d82935f"
      style="text-indent: 21pt;"
    >
      <span class="lake-fontsize-9">（5） </span
      ><span class="lake-fontsize-10"
        >被保险人所能提供的与确认保险事故的性质、原因、损失程度等有关的</span
      ><span class="lake-fontsize-10">其他证明和资料。</span>
    </p>
    <p data-lake-id="6008cd77de4f7d29c3cbebd5aac7f597">
      <strong
        ><span class="lake-fontsize-10"
          >6 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">保险合同解除</span>
    </p>
    <p
      data-lake-id="e769b92a66eebffa073d940fdba7c42c"
      style="text-align: justify; text-indent: 21pt;"
    >
      <span class="lake-fontsize-10"
        >本保险合同成立后，除本保险合同另有约定外，投保人可以要求解除本保险合同。<strong
          >但已发生任何保险金给付或已发生本保险合同约定的保险事故但尚未给付保险金的，投保人不得要求解除本保险合同。</strong
        ></span
      ><span class="lake-fontsize-10">投保人要求解除本保险合同时，应填写</span
      ><span class="lake-fontsize-10"
        >保险合同解除申请书，并提交保险单原件、保险费交付凭证和投保人身份证明。</span
      >
    </p>
    <p
      data-lake-id="04524b8715d5130f69545f0c1dceb9b9"
      style="text-align: justify; text-indent: 21pt;"
    >
      <span
        >本保险合同自本保险人接到保险合同解除申请书时终止。本保险人于接到保险</span
      ><span
        >合同解除申请书之日起三十日内向投保人退还本保险合同的未满期净保险费</span
      ><span>（</span>见释义<span>）</span>。
    </p>
    <p data-lake-id="4a578c991e33f28e7b1c2cc186732cbd">
      <strong
        ><span class="lake-fontsize-10"
          >7 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">争议处理和法律适用</span>
    </p>
    <p data-lake-id="4e834a0503eae2a67d1d06e88a4fa058">
      <strong
        ><span class="lake-fontsize-10"
          >7.1 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><strong><span class="lake-fontsize-10">争议处理</span></strong>
    </p>
    <p data-lake-id="9fc0a19f36114486391553e7168d66e2">
      合同争议解决方式由当事人在合同约定从下列两种方式中选择一种：
    </p>
    <p
      data-lake-id="52094e3370845d1a8c1cab201ad335df"
      style="text-indent: 21pt;"
    >
      （<span>一</span><span>）</span
      ><span
        >因履行本合同发生的争议，由当事人协商解决，协商不成的，提交保险</span
      ><span>单载明的仲裁委员会仲裁；</span>
    </p>
    <p
      data-lake-id="d2ee2742ba77e6afceaa4b96c5763ee1"
      style="text-indent: 21pt;"
    >
      （<span>二</span><span>）</span
      ><span
        >因履行本合同发生的争议，由当事人协商解决，协商不成的，依法向人</span
      ><span>民法院起诉。</span>
    </p>
    <p data-lake-id="28125ccf7d783e7c8c26c9906480edc9">
      <strong
        ><span class="lake-fontsize-10"
          >7.2 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">法律适用及合法性保证</span>
    </p>
    <p data-lake-id="c7c7a1f3166a7da138cd189214168ce8">
      与本保险合同有关的以及履行本保险合同产生的一切争议处理适用中华人民
      共和国法律（不包括港澳台地区法律）。
    </p>
    <p data-lake-id="99fe823677a000032877b5520e0e466e">
      <strong
        ><span class="lake-fontsize-10"
          >8 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">合法性保证</span>
    </p>
    <p data-lake-id="260aa56eb6961d811ab6a76aa99b56ed">
      本保险合同约定与《中华人民共和国保险法》等法律规定相悖之处，以法律规
    </p>
    <p data-lake-id="b1e09031087e5335ef6f30a034c8b89f">
      定为准。本保险合同未尽事宜，以法律规定为准。
    </p>
    <p data-lake-id="5831ac3cd041109aeb2be8589ae48a57">
      <strong
        ><span class="lake-fontsize-10"
          >9 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">释义</span>
    </p>
    <p data-lake-id="1cbdd43f271b6e8b366fb837d10ea7b5">
      <strong
        ><span class="lake-fontsize-10"
          >9.1 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><strong><span class="lake-fontsize-10">发病</span></strong>
    </p>
    <p data-lake-id="e669a0ba245f2c723ed17c0483ae53e0">
      发病，是指被保险人出现本保险合同所约定类型的法定传染病的前兆、
      症状或异常的身体状况，或已经显现足以促使一般普通谨慎人士引起注意并寻求诊断、治疗或护理的病症。
    </p>
    <p data-lake-id="b7256a85487fa88e7a7fade9c1e3b3f5">
      <strong
        ><span class="lake-fontsize-10"
          >9.2 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">医院、医疗机构</span>
    </p>
    <p data-lake-id="279be72e8ac0327a7f6fb1b0b17977e1">
      本保险合同约定的医院或医疗机构是指符合下列所有条件的机构：
      (1)拥有合法经营执照；
    </p>
    <p data-lake-id="83877d36b21753f017c95d07ffb2e6b1">
      (2)设立的主要目的为向受伤者和患病者提供留院治疗和护理服务；
      (3)有合格的医生和护士提供全日二十四小时的医疗和护理服务；
    </p>
    <p data-lake-id="71aa6a7f73bbd131aeacded1c0e4feb2">
      (4)非主要作为康复医院、诊所、护理、疗养、戒酒、戒毒或类似的医疗机构。
    </p>
    <p data-lake-id="414e0f57349aa0212d12eb369636f56a">
      <strong
        ><span class="lake-fontsize-10"
          >9.3 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">法定传染病</span>
    </p>
    <p data-lake-id="168df8ba7cc4b40026280ab0d714d543">
      指根据《中华人民共和国传染病防治法》列入甲、乙类传染病的病种。
    </p>
    <p data-lake-id="28f8e021583468c57258bd1a44e22737">
      <strong
        ><span class="lake-fontsize-10"
          >9.4 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">住院</span>
    </p>
    <p
      data-lake-id="53d1f9e728b0438c4e5693517c788ba7"
      style="text-align: justify; text-indent: 21pt;"
    >
      <span class="lake-fontsize-10"
        >限于被保险人因疾病或遭到意外伤害，经医生诊断必须留院治疗，并办理正式</span
      ><span class="lake-fontsize-10"
        >的出入院手续；被保险人必须连续留院二十四小时以上</span
      ><strong
        ><span class="lake-fontsize-10"
          >，但住院并不包括门诊观察室、急诊观察室、其他非正式病房、联合病房或挂床住院。</span
        ></strong
      >
    </p>
    <p
      data-lake-id="1b91b6ea247c5622466b51067a88c9cf"
      style="text-align: justify; text-indent: 21pt;"
    >
      <span>挂床住院指办理正式住院手续的被保险人，在住院期间每日非 </span>24
      小时在床、<span
        >在院，包括在住院期间连续若干日无任何治疗，只发生护理费、诊疗费、床位费的情况。</span
      >
    </p>
    <p data-lake-id="9897835d0a643aaff13dd3d9adaef93c">
      <strong
        ><span class="lake-fontsize-10"
          >9.5 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        </span></strong
      ><span class="lake-fontsize-10">未满期净保险费</span>
    </p>
    <p data-lake-id="a8bbe3cdb805c67477f2e67c0722d957">
      除另有约定外，未满期净保险费=保险费×[1-(保险单已经过天数/保险期间天 数)]
      ×（<span>1</span>-25<span>%</span><span>）</span
      ><span>。经过天数不足一天的按一天计算。</span>
    </p>
    <p
      data-lake-id="66415c368a2edb7c30b9168944879236"
      style="text-align: center;"
    >
      <a name="_Toc30550"></a
      ><a name="_Toc1211"
        ><strong style="color: #096dd9; text-align: center;"
          ><span class="lake-fontsize-10"
            >中国人民财产保险股份有限公司附加第三者责任保险条款</span
          ></strong
        ></a
      >
    </p>
    <p data-lake-id="537b47d5254d670c4c2b65e1462479f2">
      <strong><span style="color: #393939;">第一条 &nbsp; &nbsp; </span></strong
      ><span style="color: #393939;"
        >本条款系本保险单约定的主险条款的一般附加险条款。</span
      >
    </p>
    <p data-lake-id="f485f5c3187fb27b0dd495326bfc862a">
      <span class="lake-fontsize-10">第二条 &nbsp; &nbsp; &nbsp;保险责任</span>
    </p>
    <p
      data-lake-id="f118592620a6c75645d3ddc0b4f75d87"
      style="text-align: justify; text-indent: 21.9pt;"
    >
      <span>在保险期间内，被保险人（或其同住的家庭成员及雇员）在 </span
      ><span
        >保险单载明的住所，因过失造成第三者的人身伤亡或财产的直接
        损毁，依法应由被保险人承担的经济赔偿责任，保险人按照本附 </span
      ><span>加险合同的约定负责赔偿。</span>
    </p>
    <p
      data-lake-id="22050d476dca2185c42e79a5bc7f4dcb"
      style="text-indent: 21.9pt;"
    >
      <span
        >保险事故发生后，被保险人因保险事故而被提起仲裁或者诉讼的，对应由被保险人支付的仲裁或诉讼费用以及事先经保险人</span
      ><span>书面同意支付的其它必要的、合理的费用</span>（<span
        >以下简称“法律费用”</span
      ><span>）</span><span>，</span>保险人按照本保险合同约定也负责赔偿。
    </p>
    <p data-lake-id="0557cde13e74c5909671d39ae6924ba0">
      <span class="lake-fontsize-10">第三条 责任免除</span>
    </p>
    <p><strong>下列损失、费用和责任，保险人不负责赔偿：</strong></p>
    <p>
      <strong
        >（一）故意、欺诈、酗酒、殴斗以及在精神错乱、病理性痴呆情况下引起的损害赔偿责任；</strong
      >
    </p>
    <p>
      <strong
        >（二）涉及知识产权、姓名权、肖像权、名誉权、荣誉权的赔偿责任；</strong
      >
    </p>
    <p><strong>（三）精神损害赔偿责任；</strong></p>
    <p>
      <strong
        >（四）使用或驾驶各种动力与非动力交通、运输工具所造成损害赔偿责任和费用；</strong
      >
    </p>
    <p>
      <strong
        >（五）违反“国家保护环境防止污染的规定”，由污物、水、气、噪音、磁波和电子波造成的财产和人身损害事故的赔偿责任&nbsp;和费用；</strong
      >
    </p>
    <p>
      <strong
        >（六）对被保险人的家庭成员、雇员民事侵权造成的财产或人身伤害的赔偿费用；</strong
      >
    </p>
    <p><strong>（七）饲养的动物所造成的损害赔偿责任和费用；</strong></p>
    <p><strong>（八）燃放烟花爆竹所引起的民事损害赔偿责任和费用；</strong></p>
    <p><strong>（九）惩罚性赔偿及罚款；</strong></p>
    <p><strong>（十）各种间接损失。</strong></p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >第四条
        按本附加险合同约定的免赔额或按本附加险合同中载明的免赔率计算的免赔额，保险人不负责赔偿。</strong
      >
    </p>
    <p><strong>第五条&nbsp;&nbsp;责任限额及免赔额（率）</strong></p>
    <p class="ql-align-justify">
      责任限额是保险期间内保险人承担相应保险责任的最高限额。本附加险下责任限额包括第三者人身伤亡及医疗费用责任限
      额、第三者财产损失责任限额、法律费用责任限额。责任限额由
      投保人和保险人协商确定，并在保险单中载明。
    </p>
    <p>免赔额（率）由投保人与保险人在签订保险合同时协商确定，</p>
    <p><strong>并在保险单中载明。</strong></p>
    <p>
      <strong><span class="ql-cursor"> </span>第六条&nbsp;赔偿处理</strong>
    </p>
    <p class="ql-align-justify">
      （一）发生保险范围内的责任事故，保险人对每次事故的赔偿金额以当事人双方协商并经保险人同意的金额或中华人民共和
      国法院或仲裁机构依照法定程序确定的金额为准。在<span
        style="color: rgb(57, 57, 57);"
        >扣除本附加
        险合同约定的免赔额或按本保险合同载明的免赔率计算的免赔额后，在责任限额范围内计算赔偿。</span
      >
    </p>
    <p class="ql-align-justify">
      （二）被保险人向保险人申请赔偿时，应提供法律确认的文件副本及申请赔偿报告书以及投保人、被保险人所能提供的其他
      与确认保险事故的性质、原因、损失程度等有关的证明和资料；
    </p>
    <p class="ql-align-justify">
      （三）如一次责任事故赔偿金额达到相应的责任限额，则该保险责任即行中止，被保险人如需恢复原责任限额时，投保人应
      补交保险费，并由保险人出具批单批注；如一次责任事故未达至
      相应的责任限额，其有效责任限额应是责任限额减去赔偿金额后 的余额。
    </p>
    <p>第七条&nbsp;其他事项</p>
    <p class="ql-align-justify">
      凡涉及本附加险合同的约定，均应采用书面形式。主险合同
      与本附加险合同相抵触，以本附加险合同为准；本附加险合同未约定事项，以主险合同为准。主险合同效力终止，本附加险合同效力亦同时终止；主险合同无效，本附加险合同亦无效。
    </p>
    <p><br /></p>
    <p>
      <strong>第一条&nbsp;</strong
      ><span style="color: rgb(57, 57, 57);"
        >本条款系本保险单约定的主险条款的一般附加险条款。</span
      >
    </p>
    <p>第二条&nbsp;保险责任</p>
    <p>在保险期间内，主险合同载明地址内的居住房屋因遭受保险</p>
    <p class="ql-align-justify">
      合同责任范围内的事故致使房屋成为严重损坏房或危险房时，保&nbsp;险人按照本保险合同的约定一次性给付家庭辅助金，给付金额以
      保险单中载明的金额为准。
    </p>
    <p class="ql-align-justify">
      严重损坏房和危险房评定以城乡建设环境保护部发布的《房
      屋完损等级评定标准》为准。危险房是指承重的主要结构严重损
      坏，影响正常使用，不能确保住用安全的房屋。
    </p>
    <p class="ql-align-justify">
      <span style="color: rgb(57, 57, 57);">第三条 </span>其他事项
    </p>
    <p class="ql-align-justify">
      <span style="color: rgb(57, 57, 57);"
        >凡涉及本附加险合同的约定，均应采用书面形式。主险合同
        与本附加险合同相抵触之处，以本附加险合同为准；本附加险合&nbsp;同未约定事项，以主险合同为准。主险合同效力终止，本附加险
        合同效力亦同时终止；主险合同无效，本附加险合同亦无效。</span
      >
    </p>
    <p><br /></p>
    <strong style="color: #096dd9; text-align: center;"
      ><span class="lake-fontsize-10"
        >中国人民财产保险股份有限公司附加辅助金保险条款</span
      ></strong
    >
    <p>
      <strong>第一条&nbsp;</strong
      ><span style="color: rgb(57, 57, 57);"
        >本条款系本保险单约定的主险条款的一般附加险条款。</span
      >
    </p>
    <p>第二条&nbsp;保险责任</p>
    <p>在保险期间内，主险合同载明地址内的居住房屋因遭受保险</p>
    <p class="ql-align-justify">
      合同责任范围内的事故致使房屋成为严重损坏房或危险房时，保&nbsp;险人按照本保险合同的约定一次性给付家庭辅助金，给付金额以
      保险单中载明的金额为准。
    </p>
    <p class="ql-align-justify">
      严重损坏房和危险房评定以城乡建设环境保护部发布的《房
      屋完损等级评定标准》为准。危险房是指承重的主要结构严重损
      坏，影响正常使用，不能确保住用安全的房屋。
    </p>
    <p class="ql-align-justify">
      <span style="color: rgb(57, 57, 57);">第三条 </span>其他事项
    </p>
    <p class="ql-align-justify">
      <span style="color: rgb(57, 57, 57);"
        >凡涉及本附加险合同的约定，均应采用书面形式。主险合同
        与本附加险合同相抵触之处，以本附加险合同为准；本附加险合&nbsp;同未约定事项，以主险合同为准。主险合同效力终止，本附加险
        合同效力亦同时终止；主险合同无效，本附加险合同亦无效。</span
      >
    </p>
    <p><br /></p>
    <strong style="color: #096dd9; text-align: center;"
      ><span class="lake-fontsize-10"
        >中国人民财产保险股份有限公司
        <span>附加家庭成员银行卡盗刷保险条款</span></span
      ></strong
    >
    <p>投保附加险的条件</p>
    <p>
      <strong>第一条 </strong>本条款系本保险单约定的主险条款的一般附加险条款。
    </p>
    <p>附加险内容</p>
    <p>
      <strong>第二条 </strong
      >本保险合同的被保险人为具有完全民事行为能力的银行卡合法持有人。本保险合同的投保人可以为自然人或法人。
    </p>
    <p>
      <strong>第三条 </strong
      >除另有约定外，被保险人本人及其家庭成员均作为本保险合同的被保险人。被保险人的家庭成员包括其配偶、子女（包含未成年子女）、父母和被保险人配偶的父母。
    </p>
    <p>
      <strong>第四条 </strong
      >本保险合同的保险标的为被保险人名下的银行卡账户资金，包括：
    </p>
    <p>（一）被保险人名下借记卡；</p>
    <p>（二）被保险人名下信用卡主卡及与其关联的附属卡；</p>
    <p>（三）被保险人为持卡人的信用卡附属卡；</p>
    <p>（四）被保险人名下的银行网络账户；</p>
    <p>（五）被保险人名下的银行手机账户；</p>
    <p>（六）被保险人名下的存折。</p>
    <p>以上账户仅限于中国境内（不含港澳台地区）银行发行、管理的账户。</p>
    <p class="ql-align-justify">
      <strong>第五条 </strong>在保险期间内，本保险合同约定的保险标的因被他人
    </p>
    <p class="ql-align-justify">
      盗刷、盗用、复制，或被他人在银行柜面及 ATM
      机器上盗取或转账，造成的被保险人向发卡行挂失或冻结前 30
      个自然日内实际发生的损失，保险人按照本保险合同的约定负责赔偿。
    </p>
    <p>第六条 下列原因造成的损失、费用，保险人不负责赔偿：</p>
    <p>
      <strong
        >1.&nbsp;投保人、被保险人及其代表的故意、重大过失或犯罪行为；</strong
      >
    </p>
    <p><strong>2.&nbsp;行政行为或司法行为；</strong></p>
    <p>
      <strong
        >3.&nbsp;被保险人或其信用卡主卡所关联的附属卡持有人主动转账&nbsp;交易；</strong
      >
    </p>
    <p class="ql-align-justify">
      <strong
        >4.&nbsp;被保险人的银行卡被其雇佣人员（释义
        1）、代理人、家庭成员及在一起共同生活的其他亲属或共同居住人员（释义
        2）在银行柜面、ATM 机器或网络支付平台上盗取或转账；</strong
      >
    </p>
    <p>
      <strong
        >5.&nbsp;被保险人或其信用卡主卡所关联的附属卡持有人未遵循银&nbsp;行账户及第三方支付账户使用规范；</strong
      >
    </p>
    <p>
      <strong
        >6.&nbsp;被保险人的银行卡被银行工作人员利用职务之便侵占。第七条
        下列损失、费用，保险人也不负责赔偿：</strong
      >
    </p>
    <p>
      <strong
        >7.&nbsp;被保险人的银行卡通过本人绑定的理财类平台、借贷类平&nbsp;台,以及相关手机
        APP 造成的资金损失；</strong
      >
    </p>
    <p>
      <strong
        >8.&nbsp;其他平台或其他第三方已经依据服务承诺向被保险人赔偿&nbsp;的全部或部分资金损失；</strong
      >
    </p>
    <p>
      <strong
        >9.&nbsp;被他人诈骗，或他人以诈骗手段获取被保险人的银行卡账&nbsp;号、密码或其他信息后实施盗窃行为导致的资金损失；</strong
      >
    </p>
    <p>
      <strong>10. 被保险人的银行卡在借给他人使用期间所导致的资金损失；</strong>
    </p>
    <p><strong>11. 第三方支付余额账户中的资金损失；</strong></p>
    <p><strong>12. 罚款、罚金及惩罚性赔偿；</strong></p>
    <p><strong>13. 精神损害赔偿；</strong></p>
    <p><strong>14. 被保险人的间接损失；</strong></p>
    <p>
      <strong
        >15.
        本保险合同中载明的免赔额以及按本保险合同中载明的免&nbsp;赔率计算的免赔额，两者以高者为准。</strong
      >
    </p>
    <p>
      <strong>第八条 </strong>保险单中载明的保险金额是保险人对所有被保险人承
    </p>
    <p>
      担给付保险金责任的最高限额。经投保人和保险人双方约定，可选择按照以下方式分配保险金额，并在保险单中载明。
    </p>
    <p>（一）均分保险金额</p>
    <p class="ql-align-justify">
      银行卡盗刷保险责任的每人保险金额=银行卡盗刷保险的保险金额÷被保险人总人数。被保险人总人数以投保时告知为准，并在保险单中载明。保险人对每一被保险人在银行卡盗刷保险责任项
      下一次或者累计给付的保险金之和以银行卡盗刷保险责任的每人 保险金额为限。
    </p>
    <p>（二）共享保险金额</p>
    <p class="ql-align-justify">
      指所有被保险人共享银行卡盗刷保险的保险金额。保险人对所有被保险人在银行卡盗刷保险责任项下一次或者累计给付的保险
      金之和不超过银行卡盗刷保险的保险金额。
    </p>
    <p class="ql-align-justify">
      当多名被保险人发生保险事故时，保险人按照提交完整保险金申请资料并申请给付保险金的先后顺序依次计算并给付保险金，
      后续案件在剩余保险金额范围内计算并给付保险金。
    </p>
    <p><br /></p>
    <p class="ql-align-justify">
      当多名被保险人发生保险事故且同时提交完整保险金申请资
      料并申请给付保险金的，保险人按单独提交保险金申请资料的情
      况分别计算每人应给付金额。
    </p>
    <p class="ql-align-justify">
      若多名被保险人的应给付金额之和大于银行卡盗刷保险的保
      险金额与既往已给付金额之差的，保险人按下述公式计算每人实际给付金额：（该被保险人应给付金额÷多名被保险人应给付金额之和）×（银行卡盗刷保险的保险金额-既往已给付金额）。
    </p>
    <p class="ql-align-justify">
      <strong>第九条 </strong>被保险人向保险人请求赔偿时，应提交以下单证：
    </p>
    <p class="ql-align-justify">（一） 保险单正本或保险单号；</p>
    <p class="ql-align-justify">（二） 被保险人的身份证明；</p>
    <p class="ql-align-justify">
      （三） 与银行卡被盗刷、盗用、盗取、转账等相关的交易记录；
    </p>
    <p class="ql-align-justify">
      （四）
      有关损失资金的流向记录，比如涉及转账，需提供收款方姓名及账号等信息；
    </p>
    <p class="ql-align-justify">（五） 银行卡挂失或冻结时间证明；</p>
    <p class="ql-align-justify">（六） 公安机关证明；</p>
    <p class="ql-align-justify">
      （七）
      投保人、被保险人所能提供的其他与确认保险事故的性质、原因、损失程度等有关的证明和资料。
    </p>
    <p class="ql-align-justify">
      被保险人未履行前款约定的索赔资料提供义务，导致保险人
    </p>
    <p class="ql-align-justify">
      <strong>无法核实损失情况的，保险人对无法核实部分不承担赔偿责任。</strong>
    </p>
    <p class="ql-align-justify">第十条 释义 1：【雇佣人员】指</p>
    <p class="ql-align-justify">
      （1）与被保险人订立劳动合同的所有人员（含全职、兼职和临时职工）；
    </p>
    <p class="ql-align-justify">
      （2）虽未与被保险人订立劳动合同但由被保险人正式任命的人员（含董事会成员、监事会成员）；（3）虽未与被保险人订立劳动合同或未由其正式任
      命，但为其提供与职工类似服务的人员（含劳务用工合同人员）。 释义
      2：【共同居住人员】指与被保险人共同居住在同一套房屋内超过 5 天的人。
    </p>
    <p style="text-align: center;">主险与附加险关系</p>
    <p>
      <strong>第十一条 </strong
      >凡涉及本附加险合同的约定，均应采用书面形式。主险合同与本附加险合同相抵触之处，以本附加险合同为准；本附
    </p>
    <p>
      加险合同未约定事项，以主险合同为准。主险合同效力终止，本附加险合同效力亦同时终止；主险合同无效，本附加险合同亦无效。
    </p>
    <strong style="color: #096dd9; text-align: center;"
      ><span class="lake-fontsize-10"
        >中国人民财产保险股份有限公司 附加家用燃气用户意外伤害保险条款</span
      ></strong
    >
    <p><strong>1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>总则</p>
    <p><strong>1.1&nbsp;&nbsp;&nbsp;投保附加险的条件</strong></p>
    <p>
      本条款为保险合同项下主险或附加险的附加险条款，只有在投保了主险的基础&nbsp;上，方可投保本附加险。
    </p>
    <p><strong>1.2&nbsp;&nbsp;&nbsp;</strong>主险与附加险关系</p>
    <p class="ql-align-justify">
      凡涉及本附加险合同的约定，均应采用书面形式。主险合同、其他附加险合同&nbsp;与本附加险合同相抵触之处，以本附加险合同为准；本附加险合同未约定事项，以&nbsp;主险合同、其他附加险合同为准。主险合同效力终止，本附加险合同效力亦同时终&nbsp;止；主险合同无效，本附加险合同亦无效。
    </p>
    <p class="ql-align-justify">
      <strong>1.3&nbsp;&nbsp;&nbsp;</strong>被保险人
    </p>
    <p>除另有约定外，家用燃气用户可作为被保险人。</p>
    <p><strong>1.3.1&nbsp;&nbsp;</strong>被保资格的获得</p>
    <p>
      经保险人审核同意并出具保险单或批单，符合上述约定的人员即可获得被保资&nbsp;格，成为被保险人。
    </p>
    <p class="ql-align-justify">
      被保险人获得被保资格的日期以以下两者中较晚的日期为准：（1）本保险合同的保险期间起始日；（2）批单所载生效日，有多张批单增加该被保险人的，以最晚批单所载生效日为准。
    </p>
    <p class="ql-align-justify">
      <strong>1.3.2&nbsp;&nbsp;</strong>被保资格的丧失或终止
    </p>
    <p class="ql-align-justify">
      被保险人因非保险事故身故的，则自其身故之日起该被保险人的被保资格丧&nbsp;失，保险人对该被保险人所承担的保险责任随即终止。未发生保险金给付的，保险人将退还该被保险人项下的未满期净保费（释义见
      9.1）。
    </p>
    <p class="ql-align-justify"><strong>1.4&nbsp;&nbsp;&nbsp;</strong>投保人</p>
    <p>对被保险人有保险利益的团体或自然人可作为投保人。</p>
    <p><strong>2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>保障内容</p>
    <p><strong>2.1&nbsp;&nbsp;&nbsp;保险责任</strong></p>
    <p>
      投保人在投保时可选择投保 2.1.1、2.1.2 或 2.1.3
      的任一项或两项，并在保险单中载明。
    </p>
    <p><strong>2.1.1&nbsp;&nbsp;</strong>意外身故、伤残保险责任</p>
    <p class="ql-align-justify">
      在保险期间内，被保险人在获得被保资格后在保险单载明地址的居所内遭遇燃气事故（释义见&nbsp;9.2），并因该事故导致其身故或伤残的，保险人依照下列约定给付保险金，且给付各项保险金之和不超过保险单上所载的意外身故、伤残保险金额。
    </p>
    <p class="ql-align-justify">
      <strong>2.1.1.1&nbsp;</strong>意外身故保险责任
    </p>
    <p class="ql-align-justify">
      被保险人遭受燃气事故，并自该事故发生之日起 180
      日内因该事故身故的，保险人按保险单上所载的意外身故、伤残保险金额给付意外身故保险金，对该被保险&nbsp;人的保险责任终止。
    </p>
    <p class="ql-align-justify">
      被保险人因遭受燃气事故且自该事故发生日起下落不明，后经人民法院宣告死&nbsp;亡的，保险人按意外身故、伤残保险金额给付意外身故保险金。但若被保险人被宣告死亡后生还的，保险金受领人应于知道或应当知道被保险人生还后
      30 日内退还保险人给付的意外身故保险金。
    </p>
    <p class="ql-align-justify">
      被保险人身故前保险人在该保险责任项下已给付 2.1.1.2
      约定的意外伤残保险金的，意外身故保险金应扣除已给付的保险金。
    </p>
    <p class="ql-align-justify">
      <strong>2.1.1.2&nbsp;</strong>意外伤残保险责任
    </p>
    <p class="ql-align-justify">
      被保险人遭受燃气事故，并自该事故发生之日起 180
      日内因该事故造成《人身保险伤残评定标准及代码》（简称《评定标准及代码》，释义见
      9.3）所列伤残程度之一的，<strong>保险人按《评定标准及代码》所对应伤残等级的给付比例乘以保险单上&nbsp;所载的意外身故、伤残保险金额给付意外伤残保险金。</strong>如第
      180
      日治疗仍未结束的，按当日的身体情况进行伤残评定，并据此给付意外伤残保险金。
    </p>
    <p>
      （1）
      被保险人因同一意外伤害造成两处或两处以上伤残时，保险人根据《评定标准及代码》规定的多处伤残评定原则给付意外伤残保险金。
    </p>
    <p class="ql-align-justify">
      （2）
      被保险人如在本次意外伤害之前已有伤残，保险人按合并后的伤残程度在《评定标准及代码》中所对应伤残等级的给付比例扣除原有伤残程度在《评定&nbsp;标准及代码》中所对应伤残等级的给付比例，给付意外伤残保险金。
    </p>
    <p class="ql-align-justify">
      <strong>2.1.2&nbsp;&nbsp;意外医疗保险责任</strong>
    </p>
    <p class="ql-align-justify">
      被保险人遭受燃气事故，并因该事故在中华人民共和国境内（不包括港、澳、&nbsp;台地区）二级或二级以上医院或保险人认可的医疗机构（释义见
      9.4）进行治疗， 保险人按下列约定给付意外医疗保险金：
    </p>
    <p class="ql-align-justify">
      <strong>（1） </strong
      >对于被保险人在每次燃气事故中所支出的必要且合理的，符合本保险合同签发地政府颁布的社会基本医疗保险（释义见
      9.5）报销范围的医疗费用，保险人在<strong>扣除社会基本医疗保险、公费医疗、社会医疗救助或任何第三方（包括任何&nbsp;商业医疗保险）已经补偿或给付部分以及免赔额后，</strong>对其余额按本附加险合同约&nbsp;定的给付比例和门、急诊限额给付意外医疗保险金。<strong
        >免赔额、赔付比例和门、急诊限额由投保人、保险人双方约定，并在保险单中载明。</strong
      >
    </p>
    <p class="ql-align-justify">
      （2）
      保险期间届满被保险人治疗仍未结束的，保险人所负保险责任期限可按下列约定延长：门诊治疗者，自保险期间届满次日起计算，以
      15 日为限；保险期间届满被保险人仍在住院（释义见
      9.6）治疗的，自保险期间届满次日起计算，至出院之日止，最长以 90 日为限。
    </p>
    <p class="ql-align-justify">
      （3）
      保险人所负给付意外医疗保险金的责任以意外医疗保险金额为限，对被保险人一次或者累计给付意外医疗保险金达到意外医疗保险金额时，本保险合同对&nbsp;该被保险人的该项保险责任终止。
    </p>
    <p class="ql-align-justify">
      <strong>（4） </strong
      >意外医疗保险责任适用补偿原则。被保险人通过任何途径所获得的医疗费用补偿金额总和以其实际支出的医疗费用金额为限。<strong
        >被保险人已经从社会基本医疗保险、公费医疗、社会医疗救助或任何第三方（包括任何商业医疗保险）获得&nbsp;相关医疗费用补偿的，保险人仅对扣除已获得补偿后的剩余医疗费用，按照合同&nbsp;约定承担给付意外医疗保险金责任。</strong
      >
    </p>
    <p class="ql-align-justify">
      <strong>2.1.3&nbsp;&nbsp;</strong>意外身故、伤残、意外医疗保险责任
    </p>
    <p class="ql-align-justify">
      在保险期间内，被保险人在获得被保资格后在保险单载明地址的居所内遭遇燃&nbsp;气事故，并因该事故导致其身故、伤残或支出医疗费用的，保险人依照下列约定给&nbsp;付保险金，且给付各项保险金之和不超过保险单上所载的意外身故、伤残、意外医&nbsp;疗保险金额。
    </p>
    <p class="ql-align-justify">
      <strong>2.1.3.1&nbsp;</strong>意外身故保险责任
    </p>
    <p>
      被保险人遭受燃气事故，并自该事故发生之日起 180
      日内因该事故身故的，保险人按保险单上所载的意外身故、伤残、意外医疗保险金额给付意外身故保险金，&nbsp;对该被保险人的保险责任终止。
    </p>
    <p class="ql-align-justify">
      被保险人因遭受燃气事故且自该事故发生日起下落不明，后经人民法院宣告死&nbsp;亡的，保险人按意外身故、伤残、意外医疗保险金额给付意外身故保险金。但若被&nbsp;保险人被宣告死亡后生还的，保险金受领人应于知道或应当知道被保险人生还后&nbsp;30
      日内退还保险人给付的意外身故保险金。
    </p>
    <p class="ql-align-justify">
      被保险人身故前保险人在该保险责任项下已给付2.1.3.2 和2.1.3.3
      约定的意外伤残保险金和意外医疗保险金的，意外身故保险金应扣除已给付的保险金。
    </p>
    <p class="ql-align-justify">
      <strong>2.1.3.2&nbsp;</strong>意外伤残保险责任
    </p>
    <p class="ql-align-justify">
      被保险人遭受燃气事故，并自该事故发生之日起 180
      日内因该事故造成《评定标准及代码》所列伤残程度之一的，<strong>保险人按《评定标准及代码》所对应伤残等&nbsp;级的给付比例乘以保险单上所载的意外身故、伤残、意外医疗保险金额给付意外&nbsp;伤残保险金。</strong>如第
      180
      日治疗仍未结束的，按当日的身体情况进行伤残评定，并据此给付意外伤残保险金。
    </p>
    <p>
      （1）
      被保险人因同一意外伤害造成两处或两处以上伤残时，保险人根据《评定标准及代码》规定的多处伤残评定原则给付意外伤残保险金。
    </p>
    <p class="ql-align-justify">
      （2）
      被保险人如在本次意外伤害之前已有伤残，保险人按合并后的伤残程度在《评定标准及代码》中所对应伤残等级的给付比例扣除原有伤残程度在《评定&nbsp;标准及代码》中所对应伤残等级的给付比例，给付意外伤残保险金。
    </p>
    <p class="ql-align-justify">
      <strong>2.1.3.3&nbsp;意外医疗保险责任</strong>
    </p>
    <p>
      被保险人遭受燃气事故，并因该事故在中华人民共和国境内（不包括港、澳、&nbsp;台地区）二级或二级以上医院或保险人认可的医疗机构进行治疗，保险人按下列约定给付意外医疗保险金：
    </p>
    <p>
      <strong>（1） </strong
      >对于被保险人在每次燃气事故中所支出的必要且合理的，符合本保险合同签发地政府颁布的社会基本医疗保险报销范围的医疗费用，保险人在<strong
        >扣除社会基本医疗保险、公费医疗、社会医疗救助或任何第三方（包括任何商业医疗保险）
        已经补偿或给付部分以及免赔额后，</strong
      >对其余额按本附加险合同约定的给付比例和门、急诊限额给付意外医疗保险金。<strong
        >免赔额、赔付比例和门、急诊限额由投保人、保险人双方约定，并在保险单中载明。</strong
      >
    </p>
    <p class="ql-align-justify">
      （2）
      保险期间届满被保险人治疗仍未结束的，保险人所负保险责任期限可按下列约定延长：门诊治疗者，自保险期间届满次日起计算，以
      15
      日为限；保险期间届满被保险人仍在住院治疗的，自保险期间届满次日起计算，至出院之日止，最&nbsp;长以
      90 日为限。
    </p>
    <p>
      （3）
      保险人所负给付意外医疗保险金的责任以意外身故、伤残、意外医疗保险金额为限，对被保险人一次或者累计给付意外医疗保险金达到意外身故、伤残、&nbsp;意外医疗保险金额时，本保险合同对该被保险人的该项保险责任终止。
    </p>
    <p class="ql-align-justify">
      <strong>（4） </strong
      >意外医疗保险责任适用补偿原则。被保险人通过任何途径所获得的医疗费用补偿金额总和以其实际支出的医疗费用金额为限。<strong
        >被保险人已经从社会基本医疗保险、公费医疗、社会医疗救助或任何第三方（包括任何商业医疗保险）获得&nbsp;相关医疗费用补偿的，保险人仅对扣除已获得补偿后的剩余医疗费用，按照合同&nbsp;约定承担给付意外医疗保险金责任。</strong
      >
    </p>
    <p class="ql-align-justify">
      <strong>2.2&nbsp;&nbsp;&nbsp;</strong>责任免除
    </p>
    <p>
      <strong
        >因下列情形之一，导致被保险人身故、伤残或支出医疗费用的，保险人不承
        担给付保险金责任：</strong
      >
    </p>
    <p><strong>（1）&nbsp;投保人、受益人的故意行为；</strong></p>
    <p>
      <strong
        >（2）&nbsp;被保险人故意自伤或自杀，但被保险人自杀时为无民事行为能力人的除&nbsp;外；</strong
      >
    </p>
    <p><strong>（3）&nbsp;被保险人未遵医嘱服用、涂用、注射药物；</strong></p>
    <p>
      <strong
        >（4）&nbsp;被保险人受酒精、毒品、管制药物的影响，但遵医嘱使用药物的情形不&nbsp;在此限；</strong
      >
    </p>
    <p>
      <strong>（5）&nbsp;被保险人故意犯罪或抗拒依法采取的刑事强制措施；</strong>
    </p>
    <p>
      <strong
        >（6）&nbsp;被保险人存在精神和行为障碍（以世界卫生组织颁布的《疾病和有关健康问题的国际统计分类（ICD-10）》为准）；</strong
      >
    </p>
    <p>
      <strong
        >（7）&nbsp;非因意外伤害而进行的整容、整形手术，以及因任何原因进行的美容；</strong
      >
    </p>
    <p>
      <strong
        >（8）&nbsp;非因意外伤害而进行的牙科治疗或手术、视力矫正、因矫正视力而作的&nbsp;眼科验光检查，以及任何原因导致的牙齿修复或牙齿整形、安装及购买残疾用具</strong
      >
    </p>
    <p><strong>（如轮椅、假肢、假眼、假牙或者助听器等）；</strong></p>
    <p>
      <strong
        >（9）&nbsp;一般身体检查、疗养、特别护理、静养、康复性治疗、物理治疗或心理&nbsp;治疗；</strong
      >
    </p>
    <p><strong>(10)被保险人在家自设病床治疗；</strong></p>
    <p><strong>(11)投保前已有残疾的治疗和康复；</strong></p>
    <p><br /></p>
    <p>
      <strong
        >(12)未经燃气公司同意，被保险人及其家庭成员擅自拆卸、接装或移动燃
        气设备及其他违反有关法规及燃气公司安全使用燃气设备规定的行为。</strong
      >
    </p>
    <p><strong>2.3&nbsp;&nbsp;&nbsp;保险金额</strong></p>
    <p>每一被保险人的保险金额是保险人承担给付该被保险人保险金责任的最高限</p>
    <p>额。</p>
    <p>
      保险金额由投保人、保险人双方约定，并在保险单中载明。
      同一保险合同所承保的每一被保险人的保险金额应保持一致。
      每一被保险人的保险金额一经确定，在保险期间内不得变更。
    </p>
    <p><strong>2.4&nbsp;&nbsp;&nbsp;</strong>保险期间</p>
    <p>除另有约定外，保险期间为 1 年，以保险单载明的起讫时间为准。</p>
    <p><strong>2.5&nbsp;&nbsp;&nbsp;</strong>保险费</p>
    <p>保险费按户数计收，按下列公式缴纳保险费：</p>
    <p>保险费（年）=（每一被保险人保险金额/10000）×每户保险费(年)×户数</p>
    <p><strong>3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>投保人、被保险人义务</p>
    <p><strong>3.1&nbsp;&nbsp;&nbsp;交费义务</strong></p>
    <p>投保人应当在保险合同成立时交清保险费。</p>
    <p>
      投保人未按照本保险合同的约定缴纳保险费的，保险人有权按照投保人实交
      保险费与应交保险费的比例承担保险责任。
    </p>
    <p><strong>3.2&nbsp;&nbsp;&nbsp;如实告知义务</strong></p>
    <p>投保人应如实填写投保单并回答保险人提出的询问，履行如实告知义务。</p>
    <p><strong>3.3&nbsp;&nbsp;&nbsp;</strong>住址或通讯地址变更通知义务</p>
    <p class="ql-align-justify">
      投保人住所或通讯地址变更时，应及时以书面形式通知保险人。<strong
        >被保险人居所地址变更未通知的，保险人对被保险人在变更后的地址遭受的燃气事故不承担给&nbsp;付保险金的责任。</strong
      >
    </p>
    <p class="ql-align-justify">
      <strong>3.4&nbsp;&nbsp;&nbsp;</strong>其他内容变更通知义务
    </p>
    <p>
      在保险期间内，投保人需变更合同其他内容的，应以书面形式向保险人提出申&nbsp;请。保险人同意后出具批单，并在本保险合同中批注。
    </p>
    <p><strong>3.5&nbsp;&nbsp;&nbsp;</strong>保险事故通知义务</p>
    <p>
      发生保险责任范围内的事故后，投保人、被保险人或受益人应及时通知保险人，&nbsp;并书面说明事故发生的原因、经过和损失情况。
    </p>
    <p><strong>4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>保险人义务</p>
    <p>（1） 本保险合同成立后，保险人应当及时向投保人签发保险单或其他保险凭</p>
    <p>证。</p>
    <p>（2） 保险人认为投保人、被保险人或者受益人提供的有关索赔的证明和资料</p>
    <p>不完整的，应当及时一次性通知投保人、被保险人或者受益人补充提供。</p>
    <p class="ql-align-justify">
      （3）
      保险人收到被保险人或者受益人的给付保险金的请求后，应当及时作出是否属于保险责任的核定；情形复杂的，应当在三十日内作出核定。但保险责任的&nbsp;核定必须依赖于特定证明、鉴定、判决、裁定或其他证据材料的，保险人应在被保&nbsp;险人或者受益人提供或自行取得上述证据材料起三十日内作出核定。本合同另有约&nbsp;定的除外。
    </p>
    <p>
      （4） 保险人应当将核定结果通知被保险人或者受益人；对属于保险责任的，
      在与被保险人或者受益人达成给付保险金的协议后十日内，履行赔偿保险金义务。&nbsp;保险合同对给付保险金的期限有约定的，保险人应当按照约定履行给付保险金的义务。保险人依照前款约定作出核定后，对不属于保险责任的，应当自作出核定之日起三日内向被保险人或者受益人发出拒绝给付保险金通知书，并说明理由。
    </p>
    <p class="ql-align-justify">
      （5）
      保险人自收到给付保险金的请求和有关证明、资料之日起六十日内，对其赔偿保险金的数额不能确定的，应当根据已有证明和资料可以确定的数额先予支&nbsp;付；保险人最终确定给付的数额后，应当支付相应的差额。
    </p>
    <p class="ql-align-justify">
      <strong>5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>保险金申请与给付
    </p>
    <p class="ql-align-justify">
      <strong>5.1&nbsp;&nbsp;&nbsp;保险金申请</strong>
    </p>
    <p>
      保险金申请人（释义见
      9.7）向保险人申请给付保险金时，应填写保险金给付申请书，并提交以下材料。
    </p>
    <p><strong>5.1.1&nbsp;&nbsp;</strong>意外身故保险金申请</p>
    <p>（1） 保险金给付申请书；</p>
    <p>（2） 保险单；</p>
    <p>（3） 保险金申请人的身份证明；</p>
    <p class="ql-align-justify">
      （4）
      公安机关或司法部门、二级及二级以上医院或保险人认可的医疗机构出具的被保险人死亡证明或验尸报告。若被保险人为宣告死亡，保险金申请人应提供&nbsp;法院出具的宣告死亡证明文件；
    </p>
    <p>（5） 被保险人的户籍注销证明；</p>
    <p>
      （6）
      保险金申请人所能提供的与确认保险事故的性质、原因、损失程度等有关的其他证明和资料。
    </p>
    <p><strong>5.1.2&nbsp;&nbsp;</strong>意外伤残保险金申请</p>
    <p>（1） 保险金给付申请书；</p>
    <p>（2） 保险单；</p>
    <p>（3） 被保险人身份证明；</p>
    <p>
      （4）
      司法部门、二级及二级以上医院或保险人认可的医疗机构、保险人认可的其他鉴定机构出具的伤残鉴定诊断书；
    </p>
    <p>
      （5）
      保险金申请人所能提供的与确认保险事故的性质、原因、损失程度等有关的其他证明和资料。
    </p>
    <p><strong>5.1.3&nbsp;&nbsp;</strong>意外医疗保险金申请</p>
    <p>（1） 保险金给付申请书；</p>
    <p>（2） 保险单；</p>
    <p>（3） 被保险人身份证明；</p>
    <p>
      （4）
      二级及二级以上医院或保险人认可的医疗机构出具的医疗费用收据及明细清单/帐、诊断证明、病历、出院小结等；
    </p>
    <p>
      （5）
      保险金申请人所能提供的与确认保险事故的性质、原因、损失程度等有关的其他证明和资料。
    </p>
    <p><strong>5.2&nbsp;&nbsp;&nbsp;</strong>保险金的给付</p>
    <p>
      保险人在收到保险金申请人提交的本保险条款所列的材料后，应及时就是否属&nbsp;于保险责任做出核定，并将核定结果通知被保险人或受益人。
    </p>
    <p><strong>6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>保险合同解除</p>
    <p>
      本保险合同成立后，除本合同另有约定外，投保人可以要求解除本合同。<strong>但已发生任何保险金给付或已发生本合同约定的保险事故但尚未给付保险金的，投保人不得要求解除本合同。</strong>投保人要求解除本合同时，应填写保险合同解除申请书，
      并提交保险单原件、保险费交付凭证和投保人身份证明。
    </p>
    <p>
      本合同自本保险人接到保险合同解除申请书时终止。本保险人于接到保险合同&nbsp;解除申请书之日起三十日内向投保人退还本合同的未满期净保费。
    </p>
    <p><strong>7&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>争议处理和法律适用</p>
    <p><strong>7.1&nbsp;&nbsp;&nbsp;争议处理</strong></p>
    <p>合同争议解决方式由当事人在合同约定从下列两种方式中选择一种：</p>
    <p>
      （1）
      因履行本合同发生的争议，由当事人协商解决，协商不成的，提交保险&nbsp;单载明的仲裁委员会仲裁；
    </p>
    <p>
      （2）
      因履行本合同发生的争议，由当事人协商解决，协商不成的，依法向人&nbsp;民法院起诉。
    </p>
    <p><strong>7.2&nbsp;&nbsp;&nbsp;</strong>法律适用</p>
    <p>
      与本保险合同有关的以及履行本保险合同产生的一切争议处理适用中华人民&nbsp;共和国法律（不包括港澳台地区法律）。
    </p>
    <p><strong>8&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>合法性保证</p>
    <p>本保险合同约定与《中华人民共和国保险法》等法律规定相悖之处，以法律</p>
    <p><br /></p>
    <p>规定为准。本保险合同未尽事宜，以法律规定为准。</p>
    <p><strong>9&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>释义</p>
    <p><strong>9.1&nbsp;&nbsp;&nbsp;未满期净保费</strong></p>
    <p>
      除另有约定外，未满期净保费=净保险费×[1-(保险单已经过日数/保险期间的日数)]×75%。经过天数不足一天的按一天计算。
    </p>
    <p class="ql-align-justify">
      净保险费指投保人所交纳的保险费扣除每张保险单平均承担的本公司各项费&nbsp;用（含营业费用、代理费、各项税金、保险保障基金等）后的余额；如保险合同未载明，则按照以下公式计算：净保险费＝保险费×（1－25%）。
    </p>
    <p class="ql-align-justify">
      <strong>9.2&nbsp;&nbsp;&nbsp;</strong>燃气事故
    </p>
    <p>
      指因使用经燃气公司安装或同意安装的民用燃气及其所属设备引起的火灾、爆&nbsp;炸、燃气渗漏、燃气外泄等客观事件。
    </p>
    <p><strong>9.3&nbsp;&nbsp;&nbsp;</strong>《人身保险伤残评定标准及代码》</p>
    <p class="ql-align-justify">
      指由中国保险监督管理委员会发布的《人身保险伤残评定标准及代码》
      （保监发﹝2014﹞6 号、标准编号&nbsp;JR/T
      0083-2013）；如该标准重新修订，则以最新修订的文件版本为准。
    </p>
    <p class="ql-align-justify">
      <strong>9.4&nbsp;&nbsp;&nbsp;</strong>医疗机构
    </p>
    <p>
      本保险合同约定的医院或医疗机构是指符合下列所有条件的机构：
      (1)拥有合法经营执照；
    </p>
    <p>
      (2)设立的主要目的为向受伤者和患病者提供留院治疗和护理服务；
      (3)有合格的医生和护士提供全日二十四小时的医疗和护理服务；
    </p>
    <p>(4)非主要作为康复医院、诊所、护理、疗养、戒酒、戒毒或类似的医疗机构。</p>
    <p><strong>9.5&nbsp;&nbsp;&nbsp;</strong>社会基本医疗保险</p>
    <p>指职工基本医疗保险、新型农村合作医疗和城镇居民基本医疗保险。</p>
    <p><strong>9.6&nbsp;&nbsp;&nbsp;</strong>住院</p>
    <p class="ql-align-justify">
      是指被保险人确因临床需要，正式办理入院及出院手续，并确实入住医疗机构&nbsp;正式病房接受治疗的行为过程，且入住医疗机构必须达二十四小时以上且由医疗机&nbsp;构收取病房或床位费用。
    </p>
    <p class="ql-align-justify">
      <strong>9.7&nbsp;&nbsp;&nbsp;</strong>保险金申请人
    </p>
    <p>
      身故保险金申请人是指受益人或被保险人的继承人或依法享有保险金请求权&nbsp;的其他自然人；伤残和医疗保险金申请人是指被保险人。
    </p>
    <strong style="color: #096dd9; text-align: center;"
      ><span class="lake-fontsize-10"
        >中国人民财产保险股份有限公司附加救护车费用保险条款</span
      ></strong
    >
    <p>
      <strong
        >1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >总则
    </p>
    <p>
      <strong>1.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;投保附加险的条件</strong>
    </p>
    <p>本条款为保险合同项下主险或附加险的附加险条款，只有在投保了主险的基础</p>
    <p>上，方可投保本附加险。</p>
    <p>
      <strong>1.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>主险与附加险关系
    </p>
    <p>凡涉及本附加险合同的约定，均应采用书面形式。主险合同、其他附加险合同</p>
    <p>
      与本附加险合同相抵触之处，以本附加险合同为准；本附加险合同未约定事项，以主险合同为准。主险合同效力终止，本附加险合同效力亦同时终止；主险合同无效，
      本附加险合同亦无效。
    </p>
    <p>
      <strong>2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >保障内容
    </p>
    <p><strong>2.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;保险责任</strong></p>
    <p>如保险合同中包含多个条款，保险合同双方可约定本附加险所适用的具体条</p>
    <p>
      款；如未约定所适用的条款，则视为本附加险适用于保险合同中的全部条款。如本附加险所适用的条款中包含多项保险责任，还可约定本附加险所适用的具体保险责任；如未约定所适用的保险责任，则视为本附加险适用于该条款中的全部保险责任。对于本附加险所适用的任一保险责任，保险合同双方还可约定给付限额并在保险单中载明。
    </p>
    <p>投保人在投保 2.1.1 的基础上可选择投保 2.1.2，并在保险单中载明。</p>
    <p>
      <strong>2.1.1&nbsp;&nbsp;&nbsp;&nbsp;</strong>意外伤害救护车费用保险责任
    </p>
    <p class="ql-align-justify">
      在保险期间内，对于被保险人遭受意外伤害（释义见
      4.1）并自该意外伤害发生之时起 24 小时内发生的合理、必要的救护车（释义见
      4.2）费用，保险人<strong>在扣除任何第三方（包括任何商业医疗保险）已经补偿或给付部分以及本附加保险合同约定的免赔额后</strong>，对其余额按照本附加保险合同约定的给付比例、每次事故赔偿限额在保险单载明的意外伤害救护车费用保险金额内给付意外伤害救护车费用保
    </p>
    <p>险金。</p>
    <p>
      <strong>2.1.2&nbsp;&nbsp;&nbsp;&nbsp;</strong>急性疾病救护车费用保险责任
    </p>
    <p class="ql-align-justify">
      在保险期间内，对于被保险人发生保险合同内约定的急性疾病（释义见 4.3）
      并自该急性疾病发生之时起 24
      小时内发生的合理、必要的救护车费用，保险人<strong>在扣除任何第三方（包括任何商业医疗保险）已经补偿或给付部分以及本附加保险合同约定的免赔额后</strong>，对其余额按照本附加保险合同约定的给付比例、每次事故赔偿限额在保险单载明的急性疾病救护车费用保险金额内给付急性疾病救护车费用
    </p>
    <p>保险金。</p>
    <p><strong>2.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>责任免除</p>
    <p>
      <strong
        >2.2.1&nbsp;&nbsp;&nbsp;&nbsp;本附加险所适用的具体条款中列明的“责任免除”事项，也适用于本附加险合同，
        保险人不承担给付保险金责任。</strong
      >
    </p>
    <p>
      <strong
        >2.2.2&nbsp;&nbsp;&nbsp;&nbsp;对于医生诊疗费、医药费、担架费和转院时发生的费用，保险人不承担给付保险金责任。</strong
      >
    </p>
    <p>
      <strong
        >2.2.3&nbsp;&nbsp;&nbsp;&nbsp;对于本保险合同载明的免赔额，保险人不承担给付保险金的责任。</strong
      >
    </p>
    <p>
      <strong
        >3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;保险金申请</strong
      >
    </p>
    <p>保险金申请人向保险人申请给付保险金时，应填写保险金给付申请书，并提交</p>
    <p>
      以下材料。保险人按照本保险合同的约定，认为有关的证明和资料不完整的，应当及时一次性通知保险金申请人补充提供。
    </p>
    <p>（1） 本附加险所适用的具体条款中要求的各项理赔材料；</p>
    <p>（2） 救护车费用收据；</p>
    <p>（3） 保险金申请人所能提供的其他与本项申请相关的材料。</p>
    <p>
      <strong>4.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>释义
    </p>
    <p><strong>4.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;意外伤害</strong></p>
    <p>
      指以外来的、突发的、非本意的、非疾病的客观事件为直接且单独的原因致使身体受到的伤害。<strong
        >以下情形属于疾病范畴，非本条款所指意外伤害：</strong
      >
    </p>
    <p>
      <strong>（1）&nbsp;&nbsp;&nbsp;</strong
      >猝死：指由潜在疾病、身体机能障碍或其他非外来性原因所导致的、
    </p>
    <p>
      <strong
        >在出现急性症状后发生的突然死亡，以医院的诊断或公安、司法机关的鉴定为准；</strong
      >
    </p>
    <p>
      <strong>（2）&nbsp;&nbsp;&nbsp;过敏及由过敏引发的变态反应性疾病；</strong>
    </p>
    <p><strong>（3）&nbsp;&nbsp;&nbsp;高原反应；</strong></p>
    <p><strong>（4）&nbsp;&nbsp;&nbsp;中暑；</strong></p>
    <p>
      <strong
        >（5）&nbsp;&nbsp;&nbsp;细菌、病毒或其他病原体导致的感染性疾病。</strong
      >
    </p>
    <p><strong>4.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;救护车</strong></p>
    <p>指由 120 急救中心或 999 紧急救援中心派出的救护车。</p>
    <p><strong>4.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>急性疾病</p>
    <p>指被保险人突然发生、不及时救治将危及生命安危的急性疾病或身体症状。</p>
    <p>投保人和保险人双方还可以约定承保急性疾病的具体种类并在保险中载明。</p>
    <p>
      <span style="color: rgb(57, 57, 57);">中国人民财产保险股份有限公司</span>
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57); text-align: center;"
        >附加临时租房费用保险条款（2017 版）</strong
      >
    </p>
    <p><strong>&nbsp;</strong></p>
    <p>
      <span style="color: rgb(57, 57, 57); text-align: center;"
        >投保附加险的条件</span
      >
    </p>
    <p class="ql-align-justify">
      <strong style="color: rgb(57, 57, 57);">第一条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >本条款系本保险单约定的主险条款的一般附加险条款。</span
      >
    </p>
    <p>
      <span style="color: rgb(57, 57, 57); text-align: center;"
        >附加险内容</span
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第二条 </strong
      ><span style="color: rgb(57, 57, 57);">保险责任</span>
    </p>
    <p>
      <span style="color: rgb(57, 57, 57);"
        >在保险期间内，坐落于保险单载明地址的房屋因遭受主险保险合同责任范围内的事故导致该房屋无法居住，致使被保险人须临时在外租住房屋而额外支出临时租房费用时，保险人负责赔偿受损房屋合理恢复至可居住状态时的被保险人的租房费用损失。</span
      >
    </p>
    <p>
      <span style="color: rgb(57, 57, 57);"
        >本附加险合同载明的每次事故绝对免赔天数，保险人不负责赔 偿。</span
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第三条 </strong
      ><span style="color: rgb(57, 57, 57);">赔偿处理</span>
    </p>
    <p>
      <span style="color: rgb(57, 57, 57);"
        >发生本附加险责任范围内的损失时，保险人按照被保险人实际租房天数扣除每次事故绝对免赔天数后的租房天数计算赔偿。</span
      >
    </p>
    <p>
      <span style="color: rgb(57, 57, 57);">本附加险合同项下的</span
      ><strong style="color: rgb(57, 57, 57);">每次事故绝对免赔天数</strong
      ><span style="color: rgb(57, 57, 57);"
        >、每次事故赔偿天数、每日赔偿金额及保险金额由投保人与保险人协商确定，并在保
        险单中载明。</span
      >
    </p>
    <p><span style="color: rgb(57, 57, 57);">第四条 被保险人义务</span></p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >房屋遭受损失后，被保险人应尽快进行修复，不得拖延。对于无
        故拖延期间的租房费用损失，保险人不承担赔偿责任。</strong
      >
    </p>
    <p><strong style="color: rgb(57, 57, 57);">主险与附加险关系</strong></p>
    <p class="ql-align-justify">
      <span style="color: rgb(57, 57, 57);"
        >第五条
        凡涉及本附加险合同的约定，均应采用书面形式。主险合同与本附加险合同相抵触之处，以本附加险合同为准；本附加险&nbsp;合同未约定事项，以主险合同为准。主险合同效力终止，本附加险
        合同效力亦同时终止；主险合同无效，本附加险合同亦无效。</span
      >
    </p>
    <p class="ql-align-justify">
      <span style="color: rgb(57, 57, 57);">&nbsp;</span>
    </p>
    <p><br /></p>
    <strong style="color: rgb(57, 57, 57); text-align: center;">
      <p>中国人民财产保险股份有限公司附加意外伤害医疗保险（B 款）</p>
    </strong>
    <p>
      <strong
        >1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >投保附加险的条件
    </p>
    <p>本条款系本保险单约定的主险条款的一般附加险条款。</p>
    <p>
      <strong
        >2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >保障内容
    </p>
    <p><strong>2.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;保险责任</strong></p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >在保险期间内，被保险人遭受主险条款责任范围内的意外伤害，并在中华人民</strong
      >
    </p>
    <p class="ql-align-justify">
      共和国境内（不包括港、澳、台地区）二级（含）以上医院或保险人认可的医疗机构（释义见
      4.1）进行治疗，保险人按下列（1）-（3）的约定给付意外医疗保险金。
    </p>
    <p class="ql-align-justify">
      如保险合同中包含多个主险条款，可约定本附加险条款所适用的主险条款；如未约定所适用的主险条款，则视为本附加险条款适用于保险合同中的全部主险条款。如本附加险条款所适用的主险条款中包含多项意外伤害，还可约定本附加险条款所适用的意外伤害；如未约定所适用的意外伤害，则视为本附加险条款适用于该主险条款中的全部意外伤害。
    </p>
    <p>
      （1）
      对于被保险人因该意外伤害所支出的必要且合理的、符合本保险合同签发地政府颁布的基本医疗保险报销范围的医疗费用，<strong
        >保险人在扣除社会医疗保险、公费医疗或任何第三方（包括任何商业医疗保险）已经补偿或给付部分以及本附
        加保险合同约定的免赔额后</strong
      >，对其余额按本附加保险合同约定的给付比例和门诊急诊限额给付意外医疗保险金。<strong
        >免赔额、给付比例和门诊急诊限额由投保人、保险
        人双方约定，并在保险单中载明</strong
      >。
    </p>
    <p class="ql-align-justify">
      （2）
      保险期间届满被保险人治疗仍未结束的，保险人所负保险责任期限可按下列约定延长：门诊治疗者，自保险期间届满次日起计算，以
      15 日为限；保险期间届满被保险人仍在住院（释义见
      4.2）治疗的，自保险期间届满次日起计算，至出院之日止，最长以 90 日为限。
    </p>
    <p class="ql-align-justify">
      （3）
      保险人所负给付意外医疗保险金的责任以本附加保险合同项下的保险金额为限，对被保险人一次或者累计给付保险金达到该保险金额时，保险人对该被保险人的本附加保险合同项下的保险责任终止。
    </p>
    <p><strong>2.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>补偿原则</p>
    <p>本附加险条款适用补偿原则。被保险人通过任何途径所获得的医疗费用补偿金</p>
    <p class="ql-align-justify">
      额总和以其实际支出的医疗费用金额为限。被保险人已经从社会医疗保险、公费医疗或任何第三方（包括任何商业医疗保险）获得相关医疗费用补偿的，保险人仅对扣除已获得补偿后的剩余医疗费用，按照合同约定承担给付保险金责任。
    </p>
    <p><strong>2.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>责任免除</p>
    <p>
      <strong
        >2.3.1&nbsp;&nbsp;&nbsp;&nbsp;指定的主险条款中列明的“责任免除”事项，也适用于本附加险合同，保险人不承担给付保险金责任。</strong
      >
    </p>
    <p>
      <strong
        >2.3.2&nbsp;&nbsp;&nbsp;&nbsp;被保险人因下列原因导致医疗费用支出的，保险人也不承担给付保险金责任：</strong
      >
    </p>
    <p>
      <strong
        >（1）&nbsp;&nbsp;&nbsp;非因意外伤害而进行的整容、整形手术，以及因任何原因进行的美容；</strong
      >
    </p>
    <p class="ql-align-justify">
      <strong style="color: rgb(57, 57, 57);"> </strong
      ><strong
        >（2）&nbsp;&nbsp;&nbsp;非因意外伤害而进行的牙科治疗或手术，因矫正视力而作的眼科验光检查，以及任何原因导致的牙齿修复或牙齿整形、视力矫正、安装及购买康复性器具（如眼镜、轮椅、义齿、义眼、义肢、助听器等）；</strong
      >
    </p>
    <p>
      <strong
        >（3）&nbsp;&nbsp;&nbsp;一般身体检查、疗养、特别护理、静养、康复性治疗、物理治疗或心理治疗；</strong
      >
    </p>
    <p><strong>（4）&nbsp;&nbsp;&nbsp;被保险人在家自设病床治疗。</strong></p>
    <p>
      <strong
        >2.3.3&nbsp;&nbsp;&nbsp;&nbsp;对于本保险合同载明的免赔额，保险人不承担给付保险金的责任。</strong
      >
    </p>
    <p>
      <strong
        >3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;保险金申请</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >保险金申请人向保险人申请给付保险金时，应填写保险金给付申请书，并提交</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >以下材料。保险人按照本保险合同的约定，认为有关的证明和资料不完整的，应当及时一次性通知保险金申请人补充提供。</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">(1)保险金给付申请书；</strong>
    </p>
    <p><strong style="color: rgb(57, 57, 57);">(2)保险单原件；</strong></p>
    <p>
      <strong style="color: rgb(57, 57, 57);">(3)被保险人身份证明；</strong>
    </p>
    <p class="ql-align-justify">
      (4)中华人民共和国境内（不包括港、澳、台地区）二级（含）以上医院或保险人认可的医疗机构出具的医疗费用收据及明细清单/帐、诊断证明、病历、出院小结等；
    </p>
    <p class="ql-align-justify">
      (5)对于已经从社会医疗保险、公费医疗或任何第三方包括任何商业医疗保险获得相关医疗费用补偿的，应提供社会医疗保险机构、商业保险机构或其他第三方的医疗费用分割单或医疗费用结算证明；
    </p>
    <p>(6)保险金申请人所能提供的其他与本项申请相关的材料。</p>
    <p>
      <strong
        >4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >释义
    </p>
    <p><strong>4.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;医疗机构</strong></p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >本保险合同约定的医院或医疗机构是指符合下列所有条件的机构：</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">（1） 拥有合法经营执照；</strong>
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >（2） 设立的主要目的为向受伤者和患病者提供留院治疗和护理服务；</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >（3） 有合格的医生和护士提供全日二十四小时的医疗和护理服务；</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">
        （4）
        非主要作为康复医院、诊所、护理、疗养、戒酒、戒毒或类似的医疗机构。</strong
      >
    </p>
    <p><strong>4.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>住院</p>
    <p>是指被保险人确因临床需要，正式办理入院及出院手续，并确实入住医疗机构</p>
    <p>
      正式病房接受治疗的行为过程，且入住医疗机构必须达二十四小时以上且由医疗机构收取病房或床位费用。
    </p>
    <p>
      <strong
        >5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >主险与附加险关系
    </p>
    <p>凡涉及本附加险合同的约定，均应采用书面形式。主险合同与本附加险合同相</p>
    <p class="ql-align-justify">
      抵触之处，以本附加险合同为准；本附加险合同未约定事项，以主险合同为准。主险合同效力终止，本附加险合同效力亦同时终止；主险合同无效，本附加险合同亦无效。
    </p>
    <p>中国人民财产保险股份有限公司</p>
    <strong style="color: rgb(57, 57, 57); text-align: center;"
      ><span class="lake-fontsize-10"
        >附加意外伤害医疗保险条款（2009 版）</span
      ></strong
    >
    <p>
      <strong>1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>总则
    </p>
    <p><strong>1.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;合同构成</strong></p>
    <p>本条款是主险合同的附加险条款。</p>
    <p>
      本附加险合同与主险合同相抵触之处，以本附加险合同为准。本附加险合同未约定事项，以主险合同为准。主险合同效力终止，本附加险合同效力亦同时终止；
      主险合同无效，本附加险合同亦无效。
    </p>
    <p>凡涉及本附加险合同的约定，均应采用书面形式。</p>
    <p><strong>1.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>受益人</p>
    <p>本附加险合同保险金的受益人为被保险人本人。</p>
    <p>
      <strong>2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >保障内容
    </p>
    <p><strong>2.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;保险责任</strong></p>
    <p class="ql-align-justify">
      在保险期间内，被保险人遭受意外伤害（释义见
      4.1），并在中华人民共和国境内（不包括港、澳、台地区）二级或二级以上医院或保险人认可的医疗机构（释义见
      4.2）进行治疗，保险人按下列约定给付意外医疗保险金：
    </p>
    <p class="ql-align-justify">
      （1）
      对于被保险人在每次意外伤害中所支出的必要且合理的，符合本保险合同签发地政府颁布的基本医疗保险报销范围的医疗费用，保险人在扣除社会基本医疗保险或任何第三方（包括任何商业医疗保险）已经补偿或给付部分以及本附加保险合同约定的免赔额后，对其余额按本附加保险合同约定的给付比例和门、急诊限额给付意外医疗保险金。免赔额、赔付比例和门、急诊限额由投保人、保险人双方约定，并在保险单中载明。
    </p>
    <p class="ql-align-justify">
      （2）
      保险期间届满被保险人治疗仍未结束的，保险人所负保险责任期限可按下列约定延长：门诊治疗者，自保险期间届满次日起计算，以
      15 日为限；保险期间届满被保险人仍在住院（释义见
      4.3）治疗的，自保险期间届满次日起计算，至出院之日止，最长以 90 日为限。
    </p>
    <p class="ql-align-justify">
      （3）
      保险人所负给付意外医疗保险金的责任以本附加保险合同项下的保险金额为限，对被保险人一次或者累计给付保险金达到其本附加保险合同项下该被保险人的保险金额时，本附加保险合同对该被保险人的本附加保险合同项下的保险责任终止。
    </p>
    <p><strong>2.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>补偿原则</p>
    <p class="ql-align-justify">
      本附加险合同适用补偿原则。被保险人通过任何途径所获得的医疗费用补偿金额总和以其实际支出的医疗费用金额为限。被保险人已经从社会基本医疗保险或任何第三方（包括任何商业医疗保险）获得相关医疗费用补偿的，保险人仅对扣除已获得补偿后的剩余医疗费用，按照合同约定承担给付保险金责任。
    </p>
    <p><strong>2.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>责任免除</p>
    <p><strong>2.3.1&nbsp;&nbsp;&nbsp;&nbsp;原因除外</strong></p>
    <p>
      <strong
        >被保险人因下列原因导致医疗费用支出的，保险人不承担给付保险金责任：</strong
      >
    </p>
    <p><strong>（1）&nbsp;&nbsp;&nbsp;投保人的故意行为；</strong></p>
    <p>
      <strong
        >（2）&nbsp;&nbsp;&nbsp;被保险人故意自伤或自杀，但被保险人自杀时为无民事行为能力人的除外；</strong
      >
    </p>
    <p>
      <strong
        >（3）&nbsp;&nbsp;&nbsp;因被保险人挑衅或故意行为而导致的打斗、被袭击或被谋杀；</strong
      >
    </p>
    <p>
      <strong
        >（4）&nbsp;&nbsp;&nbsp;被保险人妊娠、流产、分娩、药物过敏；</strong
      >
    </p>
    <p>
      <strong
        >（5）&nbsp;&nbsp;&nbsp;被保险人接受包括美容、整容、整形手术在内的任何医疗行为而造成的意外；</strong
      >
    </p>
    <p>
      <strong
        >（6）&nbsp;&nbsp;&nbsp;被保险人未遵医嘱服用、涂用、注射药物；</strong
      >
    </p>
    <p>
      <strong
        >（7）&nbsp;&nbsp;&nbsp;被保险人受酒精、毒品、管制药物的影响；</strong
      >
    </p>
    <p>
      <strong
        >（8）&nbsp;&nbsp;&nbsp;疾病，包括但不限于高原反应、中暑、猝死（释义见
        4.4）；</strong
      >
    </p>
    <p>
      <strong>（9）&nbsp;&nbsp;&nbsp;非因意外伤害导致的细菌或病毒感染；</strong>
    </p>
    <p>
      <strong
        >（10）&nbsp;&nbsp;&nbsp;任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤、污染或辐射；</strong
      >
    </p>
    <p><strong>（11）&nbsp;&nbsp;&nbsp;恐怖袭击；</strong></p>
    <p>
      <strong
        >（12）&nbsp;&nbsp;&nbsp;非因意外伤害而进行的整容、整形手术，以及因任何原因进行的美容；</strong
      >
    </p>
    <p class="ql-align-justify">
      <strong
        >（13）&nbsp;&nbsp;&nbsp;非因意外伤害而进行的牙科治疗或手术、视力矫正、因矫正视力而作的眼科验光检查，以及任何原因导致的牙齿修复或牙齿整形、安装及购买残疾用具（如轮椅、假肢、假眼、假牙或者助听器等）；</strong
      >
    </p>
    <p>
      <strong
        >（14）&nbsp;&nbsp;&nbsp;一般身体检查、疗养、特别护理、静养、康复性治疗、物理治疗或心理治疗；</strong
      >
    </p>
    <p><strong>（15）&nbsp;&nbsp;&nbsp;被保险人在家自设病床治疗；</strong></p>
    <p><strong>（16）&nbsp;&nbsp;&nbsp;投保前已有残疾的治疗和康复。</strong></p>
    <p><strong>2.3.2&nbsp;&nbsp;&nbsp;&nbsp;期间除外</strong></p>
    <p>
      <strong
        >被保险人在下列期间遭受意外伤害导致医疗费用支出的，保险人也不承担给付保险金责任：</strong
      >
    </p>
    <p>
      <strong
        >（1）&nbsp;&nbsp;&nbsp;战争、军事行动、武装叛乱或暴乱期间；</strong
      >
    </p>
    <p>
      <strong
        >（2）&nbsp;&nbsp;&nbsp;被保险人从事违法、犯罪活动期间或被依法拘留、服刑、在逃期间；</strong
      >
    </p>
    <p>
      <strong
        >（3）&nbsp;&nbsp;&nbsp;被保险人存在精神和行为障碍（以世界卫生组织颁布的《疾病和有关健康问题的国际统计分类（ICD-10）》为准）期间；</strong
      >
    </p>
    <p class="ql-align-justify">
      <strong
        >（4）&nbsp;&nbsp;&nbsp;被保险人酒后驾车、无有效驾驶证（释义见&nbsp;4.5）驾驶或驾驶无有效行驶证的机动交通工具期间；</strong
      >
    </p>
    <p>
      <strong
        >（5）&nbsp;&nbsp;&nbsp;被保险人从事潜水（释义见&nbsp;4.6）、跳伞、热气球运动（释义见&nbsp;4.7）、攀岩运动（释义见
        4.8）、探险活动（释义见 4.9）、武术比赛（释义见
        4.10）、摔跤比赛、特技（释义见&nbsp;4.11）表演、赛马、赛车等高风险的活动期间，但被保险人作为专业运动员从事其专业运动期间除外；</strong
      >
    </p>
    <p>
      <strong>（6）&nbsp;&nbsp;&nbsp;被保险人驾驶或搭乘非商业航班期间；</strong>
    </p>
    <p class="ql-align-justify">
      <strong
        >（7）&nbsp;&nbsp;&nbsp;被保险人患有艾滋病（AIDS）或感染艾滋病病毒（HIV）（释义见
        4.12）期间。</strong
      >
    </p>
    <p><strong>2.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;保险金额</strong></p>
    <p class="ql-align-justify">
      保险金额是保险人承担给付保险金责任的最高限额。保险金额由投保人、保险人双方约定，并在保险单中载明。保险金额不得超过主险合同保险金额。保险金额一经确定，在保险期间内不得变更。
    </p>
    <p>
      <strong>3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >保险金申请
    </p>
    <p class="ql-align-justify">
      保险金申请人向保险人申请给付保险金时，应填写保险金给付申请书，并提交以下材料。保险金申请人因特殊原因不能提供以下材料的，应提供其它合法有效的材料。若保险金申请人委托他人申请的，还应提供授权委托书原件、委托人和受托
    </p>
    <p class="ql-align-justify">
      人的身份证明等相关证明文件。保险人按照本保险合同的约定，认为有关的证明和资料不完整的，应当及时一次性通知保险金申请人补充提供。<strong
        >保险金申请人未能提供有关材料，导致保险人无法核实该申请的真实性的，保险人对无法核实部分不承担给付保险金的责任。</strong
      >
    </p>
    <p>（1） 保险金给付申请书；</p>
    <p>（2） 保险单原件；</p>
    <p>（3） 被保险人身份证明；</p>
    <p>
      （4）
      二级以上（含二级）医院或保险人认可的医疗机构出具的医疗费用收据及明细清单/帐、诊断证明、病历、出院小结等；
    </p>
    <p>（5） 保险金申请人所能提供的其他与本项申请相关的材料。</p>
    <p>
      <strong>4.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>释义
    </p>
    <p><strong>4.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;意外伤害</strong></p>
    <p>
      指以外来的、突发的、非本意的、非疾病的客观事件为直接且单独的原因致使身体受到的伤害。
    </p>
    <p><strong>4.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>医疗机构</p>
    <p>
      本保险合同约定的医院或医疗机构是指符合下列所有条件的机构：
      (1)拥有合法经营执照；
    </p>
    <p>
      (2)设立的主要目的为向受伤者和患病者提供留院治疗和护理服务；
      (3)有合格的医生和护士提供全日二十四小时的医疗和护理服务；
    </p>
    <p>(4)非主要作为康复医院、诊所、护理、疗养、戒酒、戒毒或类似的医疗机构。</p>
    <p><strong>4.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>住院</p>
    <p class="ql-align-justify">
      是指被保险人确因临床需要，正式办理入院及出院手续，并确实入住医疗机构正式病房接受治疗的行为过程，且入住医疗机构必须达二十四小时以上且由医疗机构收取病房或床位费用。
    </p>
    <p><strong>4.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>猝死</p>
    <p>
      外表看似健康的人由于潜在的疾病或者功能障碍所引起的突然的出乎意料的死亡。
    </p>
    <p><strong>4.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>无有效驾驶证</p>
    <p><br /></p>
    <p>被保险人存在下列情形之一者：</p>
    <p>（1） 无驾驶证或驾驶证有效期已届满；</p>
    <p>（2） 驾驶的机动车与驾驶证载明的准驾车型不符；</p>
    <p>
      （3）
      实习期内驾驶公共汽车、营运客车或者载有爆炸物品、易燃易爆化学物品、剧毒或者放射性等危险物品的机动车，实习期内驾驶的机动车牵引挂车；
    </p>
    <p>
      （4）
      持未按规定审验的驾驶证，以及在暂扣、扣留、吊销、注销驾驶证期间驾驶机动车；
    </p>
    <p>
      （5） 使用各种专用机械车、特种车的人员无国家有关部门核发的有效操作证
      ，驾驶营业性客车的驾驶人无国家有关部门核发的有效资格证书；
    </p>
    <p>
      （6）
      依照法律法规或公安机关交通管理部门有关规定不允许驾驶机动车的其他情况下驾车。
    </p>
    <p><strong>4.6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>潜水</p>
    <p>指以辅助呼吸器材在江、河、湖、海、水库、运河等水域进行的水下运动。</p>
    <p><strong>4.7&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>热气球运动</p>
    <p>指乘热气球升空飞行的体育活动。</p>
    <p><strong>4.8&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>攀岩运动</p>
    <p>指以攀登悬崖、楼宇外墙、人造悬崖、冰崖、冰山等运动。</p>
    <p><strong>4.9&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>探险活动</p>
    <p>
      指明知在某种特定的自然条件下有失去生命或使身体受到伤害的危险，而故意使自己置身其中的行为。如江河漂流、徒步穿越沙漠或人迹罕至的原始森林等活动。
    </p>
    <p><strong>4.10&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>武术比赛</p>
    <p>
      指两人或两人以上对抗性柔道、空手道、跆拳道、散打、拳击等各种拳术及各种使用器械的对抗性比赛。
    </p>
    <p><strong>4.11&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>特技</p>
    <p>指从事马术、杂技、驯兽等特殊技能。</p>
    <p>
      <strong>4.12&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >艾滋病（AIDS）或艾滋病病毒（HIV）
    </p>
    <p>
      艾滋病病毒指人类免疫缺陷病毒，英文缩写为
      HIV。艾滋病指人类免疫缺陷病毒引起的获得性免疫缺陷综合征，英文缩写为 AIDS。
    </p>
    <p class="ql-align-justify">
      在人体血液或其它样本中检测到艾滋病病毒或其抗体呈阳性，没有出现临床症状或体征的，为感染艾滋病病毒；如果同时出现了明显临床症状或体征的，为患艾滋病。
    </p>
    <p>中国人民财产保险股份有限公司</p>
    <strong style="text-align: center; color: #096dd9;"
      ><span class="lake-fontsize-10"
        >家庭财产综合保险附加盗抢保险条款（2012 版）</span
      ></strong
    >
    <p>本条款为《中国人民财产保险股份有限公司家庭财产综合保险（2012 版）》</p>
    <p>
      （以下简称主险）的附加险条款，只有在投保了相关主险的基础上，方可投保本附加险。
    </p>
    <p><strong>一、保险标的</strong></p>
    <p>投保人可在主险保险标的范围内选择本附加险的保险标的，以保险单中载明</p>
    <p>为准。</p>
    <p><strong>二、保险责任</strong></p>
    <p>
      在保险期间内，被保险人存放于保险单所载明地址内的保险标的，由于遭受
      外来人员盗抢（指盗窃或抢劫，下同），并已经公安部门确认为盗抢行为所致的直接损失，保险人按照本附加险合同的约定负责赔偿。
    </p>
    <p>三、责任免除</p>
    <p><strong>下列原因造成的损失、费用，保险人不负责赔偿：</strong></p>
    <p>
      <strong
        >（一）保险标的因外人无明显盗窃痕迹、窗外钩物行为所致的损失；</strong
      >
    </p>
    <p><strong>（二）保险标的因门窗未锁而遭盗窃所致的损失；</strong></p>
    <p>
      <strong
        >（三）保险标的因被保险人的雇佣人员、同住人、寄宿人盗窃所致的损失；</strong
      >
    </p>
    <p>
      （四）保险财产在存放处所无人居住或无人看管超过三十天的情况下遭受的盗窃损失；
    </p>
    <p>
      <strong
        >（五）本附加险合同约定的免赔额或按本附加险合同中载明的免赔率计算的免赔额。</strong
      >
    </p>
    <p><strong>四、保险金额</strong></p>
    <p>除另有约定外，本附加险保险金额以主险对应的各分项保险金额为限，具体</p>
    <p>金额以保险单载明为准。</p>
    <p><strong>五、赔偿处理</strong></p>
    <p>（一）保险标的发生盗抢事故后，被保险人应立即向当地公安部门如实报案，</p>
    <p>并同时通知保险人。</p>
    <p>（二）被保险人向公安部门报案，并提供相关公安部门出具的盗抢证明材料</p>
    <p>后，方可向保险人办理索赔手续。</p>
    <p><br /></p>
    <p><strong>六、其他事项</strong></p>
    <p class="ql-align-justify">
      凡涉及本附加险合同的约定，均应采用书面形式。主险合同与本附加险合同相抵触，以本附加险合同为准；本附加险合同未约定事项，以主险合同为准。主险合同效力终止，本附加险合同效力亦同时终止；主险合同无效，本附加险合同亦无效。
    </p>
    <p><br /></p>
    <strong style="text-align: center; color: #096dd9;"
      ><span class="lake-fontsize-10"
        >家庭财产综合保险附加管道破裂及水渍保险条款（2012 版）</span
      ></strong
    >
    <p>本条款为《中国人民财产保险股份有限公司家庭财产综合保险（2012 版）》</p>
    <p>
      （以下简称主险）的附加险条款，只有在投保了相关主险的基础上，方可投保本附加险。
    </p>
    <p>一、保险责任</p>
    <p class="ql-align-justify">
      在保险期间内，因被保险人室内的自来水管道、下水管道和暖气管道（含暖气片）突然破裂致使水流外溢或邻居家及公共区域漏水造成被保险人保险财产的损失，保险人按照本附加险合同的约定负责赔偿。
    </p>
    <p>二、责任免除</p>
    <p><strong>由于下列原因造成的损失、费用，保险人不负责赔偿：</strong></p>
    <p>
      <strong
        >（一）因被保险人私自改动原管道设计致使管道破裂造成家庭财产的损失；</strong
      >
    </p>
    <p>
      <strong
        >（二）因被保险人管道试水、试压造成管道破裂跑水造成的家庭财产损失；</strong
      >
    </p>
    <p>
      <strong
        >（三）本附加险合同约定的免赔额或按本附加险合同中载明的免赔率计算&nbsp;的免赔额。</strong
      >
    </p>
    <p><strong>三、保险金额</strong></p>
    <p>
      保险金额以投保家庭财产保险主险合同中的保险金额为限，具体金额以保险单载明为准。
    </p>
    <p>四、其他事项</p>
    <p class="ql-align-justify">
      凡涉及本附加险合同的约定，均应采用书面形式。主险合同与本附加险合同相抵触，以本附加险合同为准；本附加险合同未约定事项，以主险合同为准。主险合同效力终止，本附加险合同效力亦同时终止；主险合同无效，本附加险合同亦无效。
    </p>
    <p><br /></p>
    <strong style="text-align: center; color: #096dd9;"
      ><span class="lake-fontsize-10"
        >家庭财产综合保险附加家用电器用电安全保险条款（2012 版）</span
      ></strong
    >
    <p>本条款为《中国人民财产保险股份有限公司家庭财产综合保险（2012 版）》</p>
    <p>
      （以下简称主险）的附加险条款，只有在投保了相关主险的基础上，方可投保本附加险。
    </p>
    <p>一、保险责任</p>
    <p>
      在保险期间内，因下列原因致使电压异常而引起被保险人家用电器的直接损毁，保险人按照本附加险合同的约定负责赔偿：
    </p>
    <p>
      （一）供电线路因遭受家庭财产保险主险保险合同责任范围内的自然灾害和意外事故；
    </p>
    <p>（二）供电部门或施工失误；</p>
    <p>（三）供电线路发生其他意外事故。</p>
    <p><strong>二、责任免除</strong></p>
    <p>由于下列原因造成的损失，保险人不负赔偿责任：</p>
    <p>
      <strong
        >（一）被保险人的故意行为以及违章用电，偷电或错误接线造成家用电器&nbsp;的损毁；</strong
      >
    </p>
    <p>
      <strong
        >（二）本附加险合同约定的免赔额或按本附加险合同中载明的免赔率计算&nbsp;的免赔额。</strong
      >
    </p>
    <p><strong>三、保险金额</strong></p>
    <p>
      保险金额以投保家庭财产保险主险合同中家用电器的保险金额为限，具体保险金额以保险单载明为准。
    </p>
    <p>四、其他事项</p>
    <p class="ql-align-justify">
      凡涉及本附加险合同的约定，均应采用书面形式。主险合同与本附加险合同相抵触，以本附加险合同为准；本附加险合同未约定事项，以主险合同为准。主险合同效力终止，本附加险合同效力亦同时终止；主险合同无效，本附加险合同亦无效。
    </p>
    <p><br /></p>
    <strong style="text-align: center; color: #096dd9;"
      ><span class="lake-fontsize-10"
        >中国人民财产保险股份有限公司家庭财产综合保险条款（2012 版）</span
      ></strong
    >
    <p style="text-align: center;">总&nbsp;则</p>
    <p>
      <strong>第一条&nbsp;</strong
      >本保险合同由保险条款、投保单、保险单、保险凭证以及批单组成。凡涉及本保险合同的约定均应采用书面形式。
    </p>
    <p style="text-align: center;">保险标的</p>
    <p>
      <strong>第二条&nbsp;</strong
      >本保险合同的保险标的为被保险人所有或使用并座落于保险单载明地址内的下列财产：
    </p>
    <p>
      （一）
      房屋及其室内附属设备（如固定装置的水暖、气暖、卫生、供水、管道煤气及供电设备、厨房配套的设备）；
    </p>
    <p>（二） 室内装潢；</p>
    <p>&nbsp;</p>
    <p>（三）室内财产：</p>
    <p>&nbsp;</p>
    <p>
      1、&nbsp;家用电器（包括安装在房屋外的空调器和太阳能热水器等家用电器的室外设备）和文体娱乐用品；
    </p>
    <p>2、&nbsp;衣物和床上用品；</p>
    <p>&nbsp;</p>
    <p>3、&nbsp;家具及其他生活用具。</p>
    <p>&nbsp;</p>
    <p>（四）存放于院内室内的农机具、农用工具、生产资料、粮食及农副产品。</p>
    <p>投保人就以上各项保险标的可以选择投保，并在保险单上载明。</p>
    <p>
      <strong>第三条&nbsp;</strong
      >下列财产未经保险合同双方特别约定并在保险单中载明的，
    </p>
    <p>不属于本保险合同的保险标的：</p>
    <p>&nbsp;</p>
    <p>
      （一）
      属于被保险人代他人保管或者与他人共有而由被保险人负责的第二条载明的财产；
    </p>
    <p>（二） 无人居住的房屋以及存放在里面的财产；</p>
    <p>&nbsp;</p>
    <p>（三） 被保险人所有的其他家庭财产。</p>
    <p><strong>第四条&nbsp;</strong>下列财产不属于本保险合同的保险标的：</p>
    <p>
      （一）
      金银、珠宝、钻石及制品，玉器、首饰、古币、古玩、字画、邮票、艺术品、稀有金属、手表等珍贵财物；
    </p>
    <p>
      （二）
      货币、票证、有价证券、文件、书籍、账册、图表、技术资料、电脑软件及电子存储设备和资料；
    </p>
    <p>（三） 日用消耗品、机动车、商业性养殖及种植物；</p>
    <p>&nbsp;</p>
    <p>（四） 仅用于生产和商业经营活动的房屋及其它财产；</p>
    <p>&nbsp;</p>
    <p>（五） 用芦席、稻草、油毛毡、麦杆、芦苇、竹竿、帆布、</p>
    <p>&nbsp;</p>
    <p>
      塑料布、纸板等为外墙、屋顶的简陋屋棚及柴房、禽畜棚；与保险房屋不成一体的厕所、围墙；
    </p>
    <p>
      （六） 政府有关部门征用、占用的房屋，违章建筑、危险建筑、非法占用的财产；
    </p>
    <p>（七） 其他不属于第二条、第三条所约定家庭财产。</p>
    <p>保险责任</p>
    <p><strong>第五条&nbsp;</strong>在保险期间内，由于下列原因造成保险标的的</p>
    <p>损失，保险人按照本保险合同的约定负责赔偿：（一）火灾、爆炸；</p>
    <p><br /></p>
    <p>
      （二）
      雷击、台风、龙卷风、暴风、暴雨、洪水、暴雪、冰雹、冰凌、泥石流、崩塌、突发性滑坡、地面突然下陷；
    </p>
    <p>
      （三）
      飞行物体及其他空中运行物体坠落，外来不属于被保险人所有或使用的建筑物和其他固定物体的倒塌。
    </p>
    <p>
      <strong>第六条&nbsp;</strong
      >保险事故发生后，被保险人为防止或减少保险标的的损失所
    </p>
    <p>支付的必要的、合理的费用，保险人按照本保险合同的约定也负责赔偿。</p>
    <p>&nbsp;</p>
    <p>责任免除</p>
    <p>
      <strong>第七条&nbsp;下列原因造成的损失、费用，保险人不负责赔偿：</strong>
    </p>
    <p><strong>（一） 核辐射、核爆炸、核污染及其他放射性污染；</strong></p>
    <p>
      <strong
        >（二） 被保险人及其家庭成员、寄宿人、雇佣人员的故意或违法行为；</strong
      >
    </p>
    <p><strong>（三） 地震、海啸及其次生灾害；</strong></p>
    <p><strong>（四） 行政行为或司法行为。</strong></p>
    <p><strong>第八条&nbsp;下列损失、费用，保险人也不负责赔偿：</strong></p>
    <p><strong>（一） 保险标的遭受保险事故引起的各种间接损失；</strong></p>
    <p class="ql-align-justify">
      <strong
        >（二）&nbsp;家用电器因使用过度、超电压、短路、断路、漏电、自身发热、烘烤等原因所造成本身的损毁；</strong
      >
    </p>
    <p class="ql-align-justify">
      <strong
        >（三）&nbsp;座落在蓄洪区、行洪区，或在江河岸边、低洼地区以及防洪堤以外当地常年警戒水位线以下的家庭财产，由于洪水所造成的一切损失；</strong
      >
    </p>
    <p><strong>（四） 保险标的本身缺陷、保管不善导致的损毁；</strong></p>
    <p>
      <strong
        >（五）
        保险标的的变质、霉烂、受潮、虫咬、自然磨损、自然损耗、自燃、烘焙所造成本身的损失；</strong
      >
    </p>
    <p>
      <strong
        >（六）
        本保险合同约定的免赔额或按本保险合同中载明的免赔率计算的免赔额。</strong
      >
    </p>
    <strong style="text-align: center; color: #096dd9;"
      ><span class="lake-fontsize-10">保险金额与免赔额（率）</span></strong
    >
    <p class="ql-align-justify">
      <strong>第九条 </strong
      >保险金额由投保人自行确定，并在保险合同中载明。其中：
    </p>
    <p class="ql-align-justify">
      （一）&nbsp;房屋及室内附属设备、室内装潢的保险金额由投保人根据当时实际价值自行确定。
    </p>
    <p class="ql-align-justify">
      （二）&nbsp;室内财产的保险金额由投保人根据当时实际价值分项目自行确定。不分项目的：按各大类财产在保险金额中所占比例确定，即室内财产中的家用电器及文体娱乐用品占
    </p>
    <p class="ql-align-justify">
      40%，衣物及床上用品占 30%，家具及其他生活用具占 30%。
    </p>
    <p>&nbsp;</p>
    <p class="ql-align-justify">
      （三）&nbsp;农机具等财产的保险金额由投保人根据当时实际价值分项目自行确定。
    </p>
    <p class="ql-align-justify">
      （四）&nbsp;特约财产的保险金额由投保人和保险人双方约定，并在保险单中载明。
    </p>
    <p class="ql-align-justify">
      <strong>第十条 </strong
      >每次事故的免赔额（率）由投保人与保险人在订立保险合同
    </p>
    <p>时协商确定，并在保险合同中载明。</p>
    <p>保险期间</p>
    <p>
      <strong>第十一条 </strong
      >除另有约定外，本保险合同的保险期间为一年，以保险单载明的起讫时间为准。
    </p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>保险人义务</p>
    <p>
      <strong>第十二条 </strong
      >本保险合同成立后，保险人应当及时向投保人签发保险单或其他保险凭证。
    </p>
    <p>
      <strong>第十三条 </strong
      >保险人按照保险合同的约定，认为被保险人提供的有关索赔的证明和资料不完整的，应当及时一次性通知投保人、被保险人补充提供。
    </p>
    <p>
      <strong>第十四条 </strong
      >保险人收到被保险人的赔偿请求后，应当及时就是否属于保险责任作出核定，并将核定结果通知被保险人。
    </p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>投保人、被保险人义务</p>
    <p>
      <strong>第十五条 </strong
      >投保人应履行如实告知义务，如实回答保险人就保险标的或被保险人的有关情况提出的询问，并如实填写投保单。
    </p>
    <p>
      <strong>第十六条 </strong
      >除本保险合同另有约定外，投保人应在保险合同成立时一次交清保险费。
    </p>
    <p>
      <strong>第十七条 </strong
      >被保险人应当遵守国家有关消防、安全、生产操作、劳动保护等方面的相关法律、法规及规定，加强管理，采取合理的预防措施，尽力避免或减少责任事故的发生，维护保险标的的安全。
    </p>
    <p>
      <strong>第十八条 </strong
      >保险标的转让的，被保险人或者受让人应当及时通知保险人。
    </p>
    <p>
      <strong>第十九条 </strong
      >在合同有效期内，如保险标的的危险程度显著增加的，被保险人应当按照合同的约定及时通知保险人，保险人可以按照合同约定增加保险费或者解除合同。
    </p>
    <p>
      <strong>第二十条 </strong
      >保险事故发生时，被保险人应当尽力采取必要的措施，防止或者减少损失。投保人、被保险人知道保险事故发生后，应当及时通知保险人。
    </p>
    <p>
      <strong>第二十一条 </strong
      >发生保险责任范围内的损失，应由有关责任方负责赔偿的，被保险人应行使或者保留向该责任方请求赔偿的权利。在保险人向有关责任方行使代位请求赔偿权利时，被保险人应当向保险人提供必要的文件和其所知道的有关情况。
    </p>
    <p>
      <strong>第二十二条&nbsp;</strong
      >被保险人请求赔偿时，应向保险人提供下列证明和资料：
    </p>
    <p>（一） 保险单正本、保险凭证；</p>
    <p>（二） 财产损失清单；</p>
    <p>
      （三） 发票、费用单据；（四）有关部门的证明。
      以及投保人、被保险人所能提供的与确认保险事故的性质、原因、损失程度等有关的其他证明和资料。
    </p>
    <p>&nbsp;</p>
    <p>赔偿处理</p>
    <p>
      <strong>第二十三条&nbsp;</strong
      >保险标的发生保险责任范围内的损失，保险人有权选择下列方式赔偿：
    </p>
    <p>
      （一） 货币赔偿：根据受损标的的实际损失和本保险合同的约定，
      以支付保险金的方式赔偿；
    </p>
    <p>
      （二）
      实物赔偿：保险人以实物替换受损保险标的，该实物应具有保险标的出险前同等的类型、结构、状态和性能；
    </p>
    <p>
      （三）&nbsp;实际修复：保险人自行或委托他人修理修复受损标的。<strong
        >第二十四条 </strong
      >保险标的遭受损失后，如果有残余价值，
    </p>
    <p>应由双方协商处理。如折归被保险人，由双方协商确定其价值，并在</p>
    <p>&nbsp;</p>
    <p>计算实际损失时扣除。</p>
    <p class="ql-align-justify">
      <strong>第二十五条&nbsp;</strong
      >发生保险责任范围内的损失时，保险人按照其实际损失扣除本保险合同约定的免赔额或按本保险合同载明的免赔率计算的免赔额后，在保险金额范围内计算赔偿。
    </p>
    <p>
      <strong>第二十六条&nbsp;</strong
      >保险标的发生部分损失，保险人履行赔偿义务后，本保险合同的保险金额自损失发生之日起按保险人的赔偿金额相应减少，
      保险人不退还保险金额减少部分的保险费。如投保人请求恢复至原保险金额，应按原约定的保险费率另行支付恢复部分的保险费。
    </p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>争议处理和法律适用</p>
    <p>
      <strong>第二十七条&nbsp;&nbsp;</strong
      >合同争议解决方式由当事人在合同约定从下列两种方式中选择一种：
    </p>
    <p>
      （一）
      因履行本合同发生的争议，由当事人协商解决，协商不成的，提交保险单载明的仲裁委员会仲裁；
    </p>
    <p>
      （二）
      因履行本合同发生的争议，由当事人协商解决，协商不成的，依法向人民法院起诉。
    </p>
    <p>
      <strong>第二十八条&nbsp;&nbsp;&nbsp;</strong
      >与本保险合同有关的以及履行本保险合同产生的一切争议，适用中华人民共和国法律（不包括港澳台地区法律）。
    </p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>其他事项</p>
    <p>
      <strong>第二十九条&nbsp;&nbsp;</strong
      >保险责任开始后，投保人要求解除保险合同的，自通知保险人之日起，保险合同解除，保险人按照保险责任开始之日起至合同解除之日止期间与保险期间的日比例计收保险费，并退还剩余部分保险费。
    </p>
    <p>
      <strong>第三十条&nbsp;&nbsp;</strong
      >保险标的发生全部损失，属于保险责任的，保险人在履行赔偿义务后，本保险合同终止；不属于保险责任的，本保险合同终止，
      保险人按照保险责任开始之日起至合同解除之日止期间与保险期间的日比例计收保险费，并退还剩余部分保险费。
    </p>
    <p class="ql-align-justify">
      <strong>第三十一条 </strong
      >本保险合同约定与《中华人民共和国保险法》等法律规定相悖之处，以法律规定为准。本保险合同未尽事宜，以法律规定为准。
    </p>
    <p>&nbsp;</p>
    <p>释义</p>
    <p>
      <strong>第三十二条&nbsp;&nbsp;</strong
      >本保险合同涉及下列术语时，适用下列释义：
    </p>
    <p>（一）火灾</p>
    <p>
      在时间或空间上失去控制的燃烧所造成的灾害。构成本保险的火灾责任必须同时具备以下三个条件：
    </p>
    <p>1.&nbsp;有燃烧现象，即有热有光有火焰；</p>
    <p>2.&nbsp;偶然、意外发生的燃烧；</p>
    <p>3.&nbsp;燃烧失去控制并有蔓延扩大的趋势。</p>
    <p>
      因此，仅有燃烧现象并不等于构成本保险中的火灾责任。在生产、生活中有目的用火，如为了防疫而焚毁沾污的衣物，点火烧荒等属正常燃烧，不同于火灾责任。
    </p>
    <p>
      因烘、烤、烫、烙造成焦糊变质等损失，既无燃烧现象，又无蔓延扩大趋势，也不属于火灾责任。
    </p>
    <p>
      电机、电器、电气设备因使用过度、超电压、碰线、弧花、漏电、自身发热所造成的本身损毁，不属于火灾责任。但如果发生了燃烧并失去控制蔓延扩大，才构成火灾责任，并对电机、电器、电气设备本身的损失负责赔偿。
    </p>
    <p>（二）爆炸</p>
    <p>爆炸分物理性爆炸和化学性爆炸。</p>
    <p class="ql-align-justify">
      1.&nbsp;&nbsp;&nbsp;物理性爆炸：由于液体变为蒸汽或气体膨胀，压力急剧增加并
      大大超过容器所能承受的极限压力，因而发生爆炸。如锅炉、空气压缩机、压缩气体钢瓶、液化气罐爆炸等。关于锅炉、压力容器爆炸的定义是：锅炉或压力容器在使用中或试压时发生破裂，使压力瞬时降到等于外界大气压力的事故，称为“爆炸事故”。
    </p>
    <p>
      2.&nbsp;&nbsp;&nbsp;化学性爆炸：物体在瞬息分解或燃烧时放出大量的热和气体，并以很大的压力向四周扩散的现象。如火药爆炸、可燃性粉尘纤维爆炸、可燃气体爆炸及各种化学物品的爆炸等。
    </p>
    <p>
      因物体本身的瑕疵，使用损耗或产品质量低劣以及由于容器内部承受“负压’（内压比外压小）造成的损失，不属于爆炸责任。
    </p>
    <p>（三） 雷击</p>
    <p>
      雷击指由雷电造成的灾害。雷电为积雨云中、云间或云地之间产生的放电现象。雷击的破坏形式分直接雷击与感应雷击两种。
    </p>
    <p>1.&nbsp;直接雷击：由于雷电直接击中保险标的造成损失，属直接雷击责任。</p>
    <p class="ql-align-justify">
      2.&nbsp;感应雷击：由于雷击产生的静电感应或电磁感应使屋内对地绝缘金属物体产生高电位放出火花引起的火灾，导致电器本身的损毁，或因雷电的高电压感应，致使电器部件的损毁，属感应雷击责任。
    </p>
    <p class="ql-align-justify">
      （四）&nbsp;台风：台风指中心附近最大平均风力 12 级或以上，即风速在 32.6
      米/秒以上的热带气旋。
    </p>
    <p class="ql-align-justify">
      （五）&nbsp;龙卷风：指一种范围小而时间短的猛烈旋风，陆地上平均最大风速在
      79 米/秒-103 米/秒，极端最大风速在100 米/秒以上。
    </p>
    <p class="ql-align-justify">
      （六） 暴风：指风力达 8 级、风速在 17.2 米/秒以上的自然风。
    </p>
    <p class="ql-align-justify">
      （七） 暴雨：指每小时降雨量达 16 毫米以上，或连续 12 小时降雨量达 30
      毫米以上，或连续 24 小时降雨量达 50 毫米以上的降雨。
    </p>
    <p class="ql-align-justify">
      （八）&nbsp;洪水：指山洪暴发、江河泛滥、潮水上岸及倒灌。但规律性的涨潮、自动灭火设施漏水以及在常年水位以下或地下渗水、水管暴裂不属于洪水责任。
    </p>
    <p class="ql-align-justify">
      （九）&nbsp;暴雪：指连续 12 小时的降雪量大于或等于 10 毫米的降雪现象。
    </p>
    <p class="ql-align-justify">
      （十） 冰雹：指从强烈对流的积雨云中降落到地面的冰块或冰球，直径大于 5
      毫米，核心坚硬的固体降水。
    </p>
    <p class="ql-align-justify">
      （十一）
      冰凌：指春季江河解冻期时冰块飘浮遇阻，堆积成坝，堵塞江道，造成水位急剧上升，以致江水溢出江道，漫延成灾。陆上有些地区，如山谷风口或酷寒致使雨雪在物体上结成冰块，成下垂形状，越结越厚，重量增加，由于下垂的拉力致使物体毁坏，也属冰凌责任。
    </p>
    <p class="ql-align-justify">
      （十二）
      泥石流：由于雨水、冰雪融化等水源激发的、含有大量泥沙石块的特殊洪流。
    </p>
    <p class="ql-align-justify">
      （十三） 崩塌：石崖、土崖、岩石受自然风化、雨蚀造成崩溃下塌，
      以及大量积雪在重力作用下从高处突然崩塌滚落。
    </p>
    <p class="ql-align-justify">
      （十四）
      突发性滑坡：斜坡上不稳的岩土体或人为堆积物在重力作用下突然整体向下滑动的现象。
    </p>
    <p class="ql-align-justify">
      （十五）
      地面突然下陷：地壳因为自然变异，地层收缩而发生突然塌陷。对于因海潮、河流、大雨侵蚀或在建筑房屋前没有掌握地层情况，地下有孔穴、矿穴，以致地面突然塌陷，也属地面突然下陷。但未按建筑施工要求导致建筑地基下陷、裂缝、倒塌等，不在此列。
    </p>
    <p>
      （十六）
      飞行物体及其他空中运行物体坠落：指空中飞行器、人造卫星、陨石坠落，吊车、行车在运行时发生的物体坠落，人工开凿或爆炸而致石方、石块、土方飞射、塌下，建筑物倒塌、倒落、倾倒，
      以及其他空中运行物体坠落。
    </p>
    <p>（十七） 地震：地壳发生的震动。</p>
    <p class="ql-align-justify">
      （十八）
      海啸：海啸是指由海底地震，火山爆发或水下滑坡、塌陷所激发的海洋巨波。
    </p>
    <p class="ql-align-justify">
      （十九）
      次生灾害：指强烈地震或海啸发生后，自然以及社会原有的状态被破坏，造成的山体滑坡、泥石流、水灾、瘟疫、火灾、爆炸、毒气泄漏、放射性物质扩散等一系列的因地震或海啸引起的灾害。
    </p>
    <p class="ql-align-justify">&nbsp;</p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >中国人民财产保险股份有限公司民用燃气火灾爆炸保险条款</strong
      >
    </p>
    <p><strong>&nbsp;</strong></p>
    <p><span style="color: rgb(57, 57, 57);">总则</span></p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第一条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >本保险合同由保险条款、投保单、保险单、保险凭证以及批单组成。凡涉及本保险合同的约定，均应采用书面形式。</span
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第二条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >经煤气/天然气公司验收同意使用燃气设备、燃气器具的居民家庭均可作为本保险合同的投保人及被保险人。家用燃气包括管道煤气、天然气和罐装液化石油气。</span
      >
    </p>
    <p><span style="color: rgb(57, 57, 57);">保险标的</span></p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第三条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >本保险合同的保险标的，是指被保险人自有的、坐落于保险单载明的地址内的下列家庭财产：</span
      >
    </p>
    <p>
      <span style="color: rgb(57, 57, 57);">（一）房屋及其室内附属设备；</span>
    </p>
    <p><span style="color: rgb(57, 57, 57);">（二）室内装潢；</span></p>
    <p>
      <span style="color: rgb(57, 57, 57);"
        >（三）家用电器和文体娱乐用品；</span
      >
    </p>
    <p><span style="color: rgb(57, 57, 57);">（四）衣物和床上用品；</span></p>
    <p>
      <span style="color: rgb(57, 57, 57);">（五）家具及其他生活用品；</span>
    </p>
    <p>
      <span style="color: rgb(57, 57, 57);"
        >(六）燃气灶、燃气热水器、燃气用表、燃气管道和液化石油气罐。</span
      >
    </p>
    <p>
      <span style="color: rgb(57, 57, 57);"
        >第四条
        下列财产未经保险合同双方特别约定并在保险合同上列明保险价值的，不属于本保险合同的保险标的：</span
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >（一）金银、珠宝、钻石及制品，玉器、首饰、古币、古玩、
        字画、邮票、艺术品、稀有金属等珍贵财物；</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >（二）货币、票证、有价证券、文件、书籍、账册、图表、
        技术资料、电脑软件及资料、以及无法鉴定价值的财产；</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >（三）日用消耗品、各种交通工具、养殖及种植物；</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >（四）用于从事工商业生产、经营活动的财产和出租用作工
        商业的房屋；</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >（五）无线通讯工具、笔、打火机、手表、各种磁带、磁盘、
        影音激光盘；</strong
      >
    </p>
    <p class="ql-align-justify">
      <strong style="color: rgb(57, 57, 57);"
        >（六）用芦席、稻草、油毛毡、麦杆、芦苇、竹竿、帆布、
        塑料布、纸板等为外墙、屋顶的简陋屋棚及柴房、禽畜棚、与保
        险房屋不成一体的厕所、围墙、无人居住的房屋以及存放在里面
        的财产；</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >（七）政府有关部门征用、占用的房屋，违章建筑、危险建
        筑、非法占用的财产、处于危险状态下的财产；</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >（八）其他不属于第三条列明的家庭财产。</strong
      >
    </p>
    <p><strong style="color: rgb(57, 57, 57);">保险责任</strong></p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第五条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >在保险期间内，由于家用燃气使用过程中引起的火灾和爆炸造成保险标的的损失,保险人依照本保险合同约定负责赔偿。</span
      >
    </p>
    <p class="ql-align-justify">
      <span style="color: rgb(57, 57, 57);"
        >前款原因造成的保险事故发生时，为抢救保险标的或防止灾害蔓延，采取必要的、合理的措施而造成保险标的的损失，保险人按照本保险合同的约定也负责赔偿。</span
      >
    </p>
    <p><br /></p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第六条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >保险事故发生后，被保险人为防止或减少保险标的的损失所支付的必要的、合理的费用，保险人按照本保险合同的约定也负责赔偿。</span
      >
    </p>
    <p><span style="color: rgb(57, 57, 57);">责任免除</span></p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >第七条 下列原因造成的损失、费用，保险人不负责赔偿：</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >（一）
        投保人、被保险人及其家庭成员或其组成人员的故意或违法、犯罪行为；</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >（二）
        战争、敌对行动、军事行动、武装冲突、罢工、骚乱、暴动、恐怖活动；</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >（三） 核辐射、核爆炸、核污染及其他放射性污染；</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >（四） 大气污染、土地污染、水污染及其他各种污染；</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >（五） 行政行为或司法行为；</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >（六） 自然灾害及燃气事故以外的其他意外事故；</strong
      >
    </p>
    <p class="ql-align-justify">
      <strong style="color: rgb(57, 57, 57);"
        >（七）
        被保险人及其家庭成员或其组成人员未经煤气/天然气公司同意，擅自拆卸、安装燃气设备，或在使用过程中违反燃气器具安装和使用的有关安全规定；</strong
      >
    </p>
    <p class="ql-align-justify">
      <strong style="color: rgb(57, 57, 57);"
        >（八） 燃气管道及附属设施在进行维修或调试。第八条
        下列损失、费用，保险人也不负责赔偿：</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >（一）因燃气事故导致的被保险人及其家庭成员或其组成人
        员的人身伤亡；</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >（二） 罚款、罚金及惩罚性赔偿；</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">（三） 精神损害赔偿；</strong>
    </p>
    <p><strong style="color: rgb(57, 57, 57);">（四） 间接损失；</strong></p>
    <p>
      <strong style="color: rgb(57, 57, 57);"
        >（五）本保险合同约定的免赔额或按本保险合同中载明的免
        赔率计算的免赔额。</strong
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">保险金额与免赔额（率）</strong>
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第九条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >保险金额由投保人参照保险标的的价值自行确定，并在保险单中载明。</span
      >
    </p>
    <p>
      <span style="color: rgb(57, 57, 57);"
        >第十条
        免赔额（率）由投保人与保险人在订立保险合同时协商确定，并在保险单中载明。</span
      >
    </p>
    <p><strong style="color: rgb(57, 57, 57);">保险期间</strong></p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第十一条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >除另有约定外，保险期间为一年，以保险单载明的起讫时间为准。</span
      >
    </p>
    <p><span style="color: rgb(57, 57, 57);">保险人义务</span></p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第十二条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >本保险合同成立后，保险人应当及时向投保人签发保险单或其他保险凭证。</span
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第十三条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >保险事故发生后，投保人、被保险人提供的有关索赔的证明和资料不完整的，保险人应当及时一次性通知投保人、被保险人补充提供。</span
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第十四条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >保险人收到被保险人的赔偿请求后，应当及时就是否属于保险责任作出核定，并将核定结果通知被保险人。</span
      >
    </p>
    <p><span style="color: rgb(57, 57, 57);">投保人、被保险人义务</span></p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第十五条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >投保人应履行如实告知义务，如实回答保险人就保险标的或被保险人的有关情况提出的询问，并如实填写投保单。</span
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第十六条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >除本保险合同另有约定外，投保人应在保险合同成立时一次交清保险费。</span
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第十七条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >被保险人应当遵守国家有关消防、安全、生产操作、劳动保护等方面的相关法律、法规及规定，加强管理，采取合理的预防措施，尽力避免或减少责任事故的发生，维护保险标的的安全。</span
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第十八条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >保险标的转让的，被保险人或者受让人应当及时通知保险人。</span
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第十九条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >在合同有效期内，如保险标的的危险程度显著增加的，被保险人应当按照合同的约定及时通知保险人，保险人可以按照合同约定增加保险费或者解除合同。</span
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第二十条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >保险事故发生时，被保险人应当尽力采取必要的措施，防止或者减少损失。投保人、被保险人知道保险事故发生后，
        应当及时通知保险人。</span
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第二十一条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >发生保险责任范围内的损失，应由有关责任方负责赔偿的，被保险人应行使或者保留向该责任方请求赔偿的权利。</span
      >
    </p>
    <p>
      <span style="color: rgb(57, 57, 57);"
        >在保险人向有关责任方行使代位请求赔偿权利时，被保险人应当向保险人提供必要的文件和其所知道的有关情况。</span
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第二十二条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >被保险人向保险人请求赔偿时，应提交以下单证：</span
      >
    </p>
    <p><span style="color: rgb(57, 57, 57);">（一） 保险单正本；</span></p>
    <p>
      <span style="color: rgb(57, 57, 57);">（二） 财产损失清单、</span
      >发票、费用单据<span style="color: rgb(57, 57, 57);">；</span>
    </p>
    <p><span style="color: rgb(57, 57, 57);">（三） 技术鉴定证明；</span></p>
    <p>
      <span style="color: rgb(57, 57, 57);"
        >（四）
        投保人、被保险人所能提供的其他与确认保险事故的性质、原因、损失程度等有关的证明和资料。</span
      >
    </p>
    <p><span style="color: rgb(57, 57, 57);">赔偿处理</span></p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第二十三条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >保险标的发生保险责任范围内的损失，保险人有权选择下列方式赔偿：</span
      >
    </p>
    <p>
      <span style="color: rgb(57, 57, 57);"
        >货币赔偿：保险人以支付保险金的方式赔偿；</span
      >
    </p>
    <p>
      <span style="color: rgb(57, 57, 57);"
        >实物赔偿：保险人以实物替换受损标的，该实物应具有保险标的出险前同等的类型、结构、状态；</span
      >
    </p>
    <p>
      <span style="color: rgb(57, 57, 57);"
        >实际修复：保险人自行或委托他人修理修复受损标的。</span
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第二十四条 </strong
      >保险标的遭受损失后，如果有残余价值，应由双方协商处理。如折归被保险人，由双方协商确定其价值，并在计算实际损失时扣除。
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第二十五条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >发生保险责任范围内的损失时，保险人按照其实际损失扣除本保险合同约定的免赔额或按本保险合同载明的免赔率计算的免赔额后，在保险金额范围内计算赔偿。</span
      >
    </p>
    <p class="ql-align-justify">
      <strong style="color: rgb(57, 57, 57);">第二十六条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >保险标的发生部分损失，保险人履行赔偿义务后，本保险合同的保险金额自损失发生之日起按保险人的赔偿金额相应减少，保险人不退还保险金额减少部分的保险费。如投保人请求恢复至原保险金额，应按原约定的保险费率另行支付恢复部分从投保人请求的恢复日期起至保险期间届满之日止按日比例计算的保险费。</span
      >
    </p>
    <p><span style="color: rgb(57, 57, 57);">争议处理和法律适用</span></p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第二十七条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >合同争议解决方式由当事人在合同约定从下列两种方式中选择一种：</span
      >
    </p>
    <p>
      <span style="color: rgb(57, 57, 57);"
        >（一）因履行本合同发生的争议，由当事人协商解决，协商不成的，提交保险单载明的仲裁委员会仲裁；</span
      >
    </p>
    <p>
      <span style="color: rgb(57, 57, 57);"
        >（二）因履行本合同发生的争议，由当事人协商解决，协商不成的，依法向人民法院起诉。</span
      >
    </p>
    <p class="ql-align-justify">
      <strong style="color: rgb(57, 57, 57);">第二十八条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >与本保险合同有关的以及履行本保险合同产生的一切争议处理适用中华人民共和国法律（不包括港澳台地区法律）。</span
      >
    </p>
    <p><span style="color: rgb(57, 57, 57);">其他事项</span></p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第二十九条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >保险责任开始前，投保人要求解除保险合同的，
        应当按照保险合同约定的比例向保险人支付退保手续费，具体比例由投保人和保险人协商确定，并在保险单中载明，保险人应当退还剩余部分保险费。</span
      >
    </p>
    <p class="ql-align-justify">
      <span style="color: rgb(57, 57, 57);"
        >保险责任开始后，投保人要求解除保险合同的，自通知保险人之日起，保险合同解除，保险人按照保险责任开始之日起至合同解除之日止期间与保险期间的日比例计收保险费，并退还剩余部分保险费。</span
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第三十条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >保险标的发生全部损失，属于保险责任的，保险人在履行赔偿义务后，本保险合同终止；不属于保险责任的，本保险合同终止，保险人按照保险责任开始之日起至合同解除之日止期间与保险期间的日比例计收保险费，并退还剩余部分保险费。</span
      >
    </p>
    <p>
      <strong style="color: rgb(57, 57, 57);">第三十一条 </strong
      ><span style="color: rgb(57, 57, 57);"
        >本保险合同约定与《中华人民共和国保险法》等法律规定相悖之处，以法律规定为准。本保险合同未尽事宜，以法律规定为准。</span
      >
    </p>
    <strong style="text-align: center; color: #096dd9;"
      ><span class="lake-fontsize-10"
        >中国人民财产保险股份有限公司意外伤害保险条款</span
      ></strong
    >
    <p>
      <strong
        >1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;总则</strong
      >
    </p>
    <p><strong>1.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;合同构成</strong></p>
    <p>本保险合同由保险条款、投保单、保险单或其他保险凭证、批单组成。凡涉及</p>
    <p>本保险合同的约定，均应采用书面形式。</p>
    <p><strong>1.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>被保险人</p>
    <p>
      年龄在 6 个月至 65 周岁（释义见 8.1）、身体健康、能正常工作或正常生活的
    </p>
    <p>自然人可作为被保险人。</p>
    <p>
      <strong
        >2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >保障内容
    </p>
    <p><strong>2.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;保险责任</strong></p>
    <p>
      保险期间内被保险人遭受意外伤害（释义见&nbsp;8.2），并因该意外伤害导致其身
    </p>
    <p>
      故、残疾的，保险人依照下列约定给付保险金，且给付各项保险金之和不超过保险金额。
    </p>
    <p><strong>2.1.1&nbsp;&nbsp;&nbsp;&nbsp;</strong>身故保险责任</p>
    <p>在保险期间内被保险人遭受意外伤害，并自意外伤害发生之日起 180 日内因该</p>
    <p>
      意外伤害身故的，保险人按保险金额给付身故保险金，对该被保险人的保险责任终止。
    </p>
    <p>
      被保险人因遭受意外伤害且自该意外伤害发生日起下落不明，后经人民法院宣告死亡的，保险人按保险金额给付身故保险金。但若被保险人被宣告死亡后生还的，
      保险金受领人应于知道或应当知道被保险人生还后 30
      日内退还保险人给付的身故保险金。
    </p>
    <p>
      被保险人身故前保险人已给付 2.1.2
      约定的残疾保险金的，身故保险金应扣除已给付的保险金。
    </p>
    <p><strong>2.1.2&nbsp;&nbsp;&nbsp;&nbsp;</strong>残疾保险责任</p>
    <p class="ql-align-justify">
      在保险期间内被保险人遭受意外伤害，并自该意外伤害发生之日起 180 日内因
    </p>
    <p class="ql-align-justify">
      该意外伤害造成本保险合同所附《人身保险伤残评定标准》（释义见&nbsp;8.3）（简称《评定标准》）所列伤残程度之一的，保险人按《评定标准》所对应伤残等级的给付比例乘以保险金额给付残疾保险金。如第
      180 日治疗仍未结束的，按当日的身体情况进行伤残评定，并据此给付残疾保险金。
    </p>
    <p>
      （1）
      被保险人因同一意外伤害造成两处或两处以上伤残时，保险人根据《评定标准》规定的多处伤残评定原则给付残疾保险金。
    </p>
    <p class="ql-align-justify">
      （2）
      被保险人如在本次意外伤害之前已有残疾，保险人按合并后的残疾程度在《评定标准》中所对应伤残等级的给付比例扣除原有残疾程度在《评定标准》中所对应伤残等级的给付比例，给付残疾保险金。
    </p>
    <p><strong>2.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>责任免除</p>
    <p><strong>2.2.1&nbsp;&nbsp;&nbsp;&nbsp;原因除外</strong></p>
    <p>
      <strong
        >被保险人因下列原因而导致身故或残疾的，保险人不承担给付保险金责任：</strong
      >
    </p>
    <p><strong>（1）&nbsp;&nbsp;&nbsp;投保人的故意行为；</strong></p>
    <p>
      <strong
        >（2）&nbsp;&nbsp;&nbsp;故意自伤或自杀，但被保险人自杀时为无民事行为能力人的除外；</strong
      >
    </p>
    <p>
      <strong
        >（3）&nbsp;&nbsp;&nbsp;因被保险人挑衅或故意行为而导致的打斗、被袭击或被谋杀；</strong
      >
    </p>
    <p><strong>（4）&nbsp;&nbsp;&nbsp;妊娠、流产、分娩、药物过敏；</strong></p>
    <p>
      <strong
        >（5）&nbsp;&nbsp;&nbsp;接受包括美容、整容、整形手术在内的任何医疗行为而造成的意外；</strong
      >
    </p>
    <p>
      <strong>（6）&nbsp;&nbsp;&nbsp;未遵医嘱服用、涂用、注射药物；</strong>
    </p>
    <p>
      <strong>（7）&nbsp;&nbsp;&nbsp;受酒精、毒品、管制药物的影响；</strong>
    </p>
    <p>
      <strong
        >（8）&nbsp;&nbsp;&nbsp;疾病，包括但不限于高原反应、中暑、猝死（释义见
        8.4）；</strong
      >
    </p>
    <p>
      <strong>（9）&nbsp;&nbsp;&nbsp;非因意外伤害导致的细菌或病毒感染；</strong>
    </p>
    <p>
      <strong
        >（10）&nbsp;&nbsp;&nbsp;&nbsp;任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤、污染或辐射；</strong
      >
    </p>
    <p><strong>（11）&nbsp;&nbsp;&nbsp;恐怖袭击；</strong></p>
    <p><br /></p>
    <p><strong>2.2.2&nbsp;&nbsp;&nbsp;&nbsp;期间除外</strong></p>
    <p>
      <strong
        >被保险人在下列期间遭受意外伤害导致身故或残疾的，保险人不承担给付保险金责任：</strong
      >
    </p>
    <p>
      <strong
        >（1）&nbsp;&nbsp;&nbsp;战争、军事行动、武装叛乱或暴乱期间；</strong
      >
    </p>
    <p>
      <strong
        >（2）&nbsp;&nbsp;&nbsp;从事违法、犯罪活动行为或被依法拘留、服刑、在逃期间；</strong
      >
    </p>
    <p>
      <strong
        >（3）&nbsp;&nbsp;&nbsp;存在精神和行为障碍（以世界卫生组织颁布的《疾病和有关健康问题的国际统计分类（ICD-10）》为准）期间；</strong
      >
    </p>
    <p>
      <strong
        >（4）&nbsp;&nbsp;&nbsp;从事高风险运动（释义见 8.5）期间,
        但被保险人作为专业运动员从事其专业运动除外。</strong
      >
    </p>
    <p>
      <strong
        >（5）&nbsp;&nbsp;&nbsp;艾滋病（AIDS）或感染艾滋病病毒（HIV）（释义见
        8.6）期间；</strong
      >
    </p>
    <p><strong>（6）&nbsp;&nbsp;&nbsp;驾驶或搭乘非商业航班期间；</strong></p>
    <p>
      <strong
        >（7）&nbsp;&nbsp;&nbsp;被保险人酒后驾驶（释义见
        8.7）、无有效驾驶证（释义见 8.8）驾驶或驾驶无有效行驶证（释义见
        8.9）的机动交通工具期间；</strong
      >
    </p>
    <p><strong>2.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;保险金额</strong></p>
    <p>保险金额是保险人承担给付保险金责任的最高限额。</p>
    <p>
      保险金额由投保人、保险人双方约定，并在保险单中载明。保险金额一经确定，在保险期间内不得变更。
    </p>
    <p><strong>2.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>保险期间</p>
    <p>除另有约定外，保险期间为 1 年，以保险单载明的起讫时间为准。</p>
    <p>
      <strong
        >3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >投保人、被保险人义务
    </p>
    <p><strong>3.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;交费义务</strong></p>
    <p>投保人应当在保险合同成立时交清保险费。</p>
    <p><strong>3.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>如实告知义务</p>
    <p>投保人应如实填写投保单并回答保险人提出的询问，履行如实告知义务。</p>
    <p>
      <strong>3.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >职业或者工种变更通知义务
    </p>
    <p>被保险人变更职业或工种时，投保人或被保险人应在 10 日内以书面形式通知</p>
    <p>保险人。</p>
    <p>
      被保险人所变更的职业或工种，依照保险人职业分类其危险性减低的，保险人自接到通知后，自职业变更之日起，退还变更前后职业或工种对应的保险费差额；
      其危险性增加的，保险人在接到通知后，自职业变更之日起，增收变更前后职业或工种对应的保险费差额。
    </p>
    <p class="ql-align-justify">
      <strong
        >被保险人所变更的职业或工种依照保险人职业分类在拒保范围内的，保险人有权解除本保险合同。</strong
      >如保险人解除合同的，本保险合同自保险人接到通知之日的次日零时起终止，保险人退还现金价值（释义见
      8.10）。
    </p>
    <p class="ql-align-justify">
      被保险人变更职业或工种且未依照本保险合同约定通知保险人而发生保险事故的，若依照保险人职业分类不在拒保范围内但其危险性增加的，保险人按其原保险费与新职业或工种所对应的保险费的比例计算并给付保险金；若被保险人所变更的职业或工种依照保险人职业分类在拒保范围内的，保险人不承担给付保险金的责任，保险人退还现金价值。
    </p>
    <p class="ql-align-justify">
      <strong
        >3.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;住址或通讯地址变更通知义务</strong
      >
    </p>
    <p>投保人住所或通讯地址变更时，应及时以书面形式通知保险人。</p>
    <p>
      <strong>3.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >其他内容变更通知义务
    </p>
    <p>在保险期间内，投保人需变更合同其他内容的，应以书面形式向保险人提出申</p>
    <p>请。保险人同意后出具批单，并在本保险合同中批注。</p>
    <p>
      <strong>3.6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>保险事故通知义务
    </p>
    <p>
      发生保险责任范围内的事故后，投保人、被保险人或受益人应及时通知保险人，
    </p>
    <p>并书面说明事故发生的原因、经过和损失情况。</p>
    <p class="ql-align-justify">
      <strong
        >4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >保险金申请与给付
    </p>
    <p class="ql-align-justify">
      <strong>4.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;保险金申请</strong>
    </p>
    <p class="ql-align-right">
      保险金申请人（释义见 8.11）向保险人申请给付保险金时，应填写保险金给
    </p>
    <p class="ql-align-justify">
      付申请书，并提交以下材料。保险人按照本保险合同的约定，认为有关的证明和资料不完整的，应当及时一次性通知保险金申请人补充提供。
    </p>
    <p><strong>4.1.1&nbsp;&nbsp;&nbsp;&nbsp;</strong>身故保险金申请</p>
    <p>（1） 保险金给付申请书；</p>
    <p>（2） 保险单原件；</p>
    <p>（3） 保险金申请人的身份证明；</p>
    <p class="ql-align-justify">
      （4）
      公安部门或司法部门、二级及二级以上医院或保险人认可的医疗机构出具的被保险人死亡证明或验尸报告。若被保险人为宣告死亡，保险金申请人应提供法院出具的宣告死亡证明文件；
    </p>
    <p>（5） 被保险人的户籍注销证明；</p>
    <p>
      （6）
      保险金申请人所能提供的与确认保险事故的性质、原因、损失程度等有关的其他证明和资料。
    </p>
    <p><strong>4.1.2&nbsp;&nbsp;&nbsp;&nbsp;</strong>残疾保险金申请</p>
    <p>（1） 保险金给付申请书；</p>
    <p>（2） 保险单原件；</p>
    <p>（3） 被保险人身份证明；</p>
    <p>
      （4）
      司法部门、二级及二级以上医院或保险人认可的医疗机构、保险人认可的其他鉴定机构出具的残疾鉴定诊断书；
    </p>
    <p>
      （5）
      保险金申请人所能提供的与确认保险事故的性质、原因、损失程度等有关的其他证明和资料。
    </p>
    <p><strong>4.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>保险金的给付</p>
    <p>保险人在收到保险金申请人提交的本保险条款所列的材料后，应及时就是否属</p>
    <p>于保险责任做出核定，并将核定结果通知被保险人或受益人。</p>
    <p>
      <strong
        >5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >保险合同解除
    </p>
    <p>投保人解除合同的，保险人应当自收到解除合同通知之日起三十日内，按照合</p>
    <p>同约定退还保险单的现金价值。</p>
    <p>
      <strong
        >6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >争议处理和法律适用
    </p>
    <p><strong>6.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;争议处理</strong></p>
    <p>合同争议解决方式由当事人在合同约定从下列两种方式中选择一种：</p>
    <p>
      （一）因履行本合同发生的争议，由当事人协商解决，协商不成的，提交保险单载明的仲裁委员会仲裁；
    </p>
    <p>
      （二）因履行本合同发生的争议，由当事人协商解决，协商不成的，依法向人民法院起诉。
    </p>
    <p><strong>6.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>法律适用</p>
    <p>与本保险合同有关的以及履行本保险合同产生的一切争议处理适用中华人民</p>
    <p>共和国法律（不包括港澳台地区法律）。</p>
    <p>
      <strong
        >7&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >合法性保证
    </p>
    <p>本保险合同约定与《中华人民共和国保险法》等法律规定相悖之处，以法律</p>
    <p>规定为准。本保险合同未尽事宜，以法律规定为准。</p>
    <p>
      <strong
        >8&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >释义
    </p>
    <p><strong>8.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;周岁</strong></p>
    <p>以法定身份证明文件中记载的出生日期为基础计算的实足年龄。</p>
    <p><strong>8.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>意外伤害</p>
    <p>指以外来的、突发的、非本意的、非疾病的客观事件为直接且单独的原因致</p>
    <p>使身体受到的伤害。</p>
    <p>
      <strong>8.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >《人身保险伤残评定标准》
    </p>
    <p>指中国保险行业协会发布的人身保险伤残程度评定与保险金给付比例标准，</p>
    <p>
      详见《关于印发&lt;人身保险伤残评定标准&gt;的通知》（中保协发【2013】88
      号）。
    </p>
    <p><strong>8.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>猝死</p>
    <p>外表看似健康的人由于潜在的疾病或者功能障碍所引起的突然的意外的死</p>
    <p>亡。</p>
    <p><strong>8.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>高风险运动</p>
    <p><br /></p>
    <p>
      指潜水、跳伞、热气球运动、滑翔机、滑翔翼、滑翔伞、动力伞、攀岩运动、探险活动、武术比赛、摔跤比赛、特技表演、赛马、赛车及保险单载明的其他运动。
    </p>
    <p>
      潜水：指以辅助呼吸器材在江、河、湖、海、水库、运河等水域进行的水下运动，但穿着救生衣在水面进行的浮潜活动除外。
    </p>
    <p>热气球运动：指乘热气球升空飞行的体育活动。</p>
    <p>攀岩活动：指攀登悬崖、楼宇外墙、人造悬崖、冰崖、冰山等运动。</p>
    <p class="ql-align-justify">
      探险活动：指明知在某种特定的自然条件下有失去生命或使身体受到伤害的危险，而故意使自己置身其中的行为。如江河漂流、非固定路线徒步、徒步穿越沙漠或人迹罕至的原始森林等活动。
    </p>
    <p>
      武术比赛：指两人或两人以上对抗性柔道、空手道、跆拳道、散打、拳击等各种拳术及各种使用器械的对抗性比赛。
    </p>
    <p>特技：指从事马术、杂技、驯兽等特殊技能。</p>
    <p>
      <strong>8.6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong
      >艾滋病（AIDS）或艾滋病病毒（HIV）
    </p>
    <p class="ql-align-justify">
      艾滋病病毒指人类免疫缺陷病毒，英文缩写为 HIV。艾滋病指人类免疫缺陷病
    </p>
    <p class="ql-align-justify">
      毒引起的获得性免疫缺陷综合征，英文缩写为 AIDS。
    </p>
    <p class="ql-align-justify">
      在人体血液或其它样本中检测到艾滋病病毒或其抗体呈阳性，没有出现临床症状或体征的，为感染艾滋病病毒；如果同时出现了明显临床症状或体征的，为患艾滋病。
    </p>
    <p><strong>8.7&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>酒后驾驶</p>
    <p>指经检测或者鉴定，发生事故时车辆驾驶人员每百毫升血液中的酒精含量达到</p>
    <p>
      或者超过一定的标准，公安机关交通管理部门依据《道路交通安全法》的规定认定为饮酒后驾驶或者醉酒后驾驶。
    </p>
    <p><strong>8.8&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>无有效驾驶证</p>
    <p>被保险人存在下列情形之一</p>
    <p>（1） 无驾驶证或驾驶证有效期已届满；</p>
    <p>（2） 驾驶的机动车与驾驶证载明的准驾车型不符；</p>
    <p class="ql-align-justify">
      （3）
      实习期内驾驶执行任务的警车、消防车、救护车、工程救险车；实习期内驾驶公共汽车、营运客车或者载有爆炸物品、易燃易爆化学物品、剧毒或者放射性等危险物品的机动车，实习期内驾驶的机动车牵引挂车；
    </p>
    <p>
      （4）
      持未按规定审验的驾驶证，以及在暂扣、扣留、吊销、注销驾驶证期间驾驶机动车；
    </p>
    <p>
      （5） 使用各种专用机械车、特种车的人员无国家有关部门核发的有效操作证
      ，驾驶营业性客车的驾驶人无国家有关部门核发的有效资格证书；
    </p>
    <p>
      （6）
      依照法律法规或公安机关交通管理部门有关规定不允许驾驶机动车的其他情况下驾车。
    </p>
    <p><strong>8.9&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>无有效行驶证</p>
    <p>发生保险事故时被保险人驾驶的机动车无公安机关交通管理部门、农机部门等</p>
    <p>
      政府管理部门核发的行驶证或号牌，或行驶证不在有效期内，或该机动车未按规定检验或检验不合格。
    </p>
    <p><strong>8.10&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>现金价值</p>
    <p>除另有约定外，现金价值=保险费×[1-(保险单已经过天数/保险期间天数)]</p>
    <p>×75%。经过天数不足一天的按一天计算。</p>
    <p><strong>8.11&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>保险金申请人</p>
    <p>身故保险金申请人是指受益人或被保险人的继承人或依法享有保险金请求权</p>
    <p class="ql-align-justify">的其他自然人；其他保险金申请人是指被保险人。</p>
  </div>
</template>

<script>
export default {
  name: "InsureService",
};
</script>

<style lang="sass" scoped>
#insure
  padding: 15pt 10pt 15pt 15pt
  color: #000000
  p
    margin-bottom: 10pt
</style>
